import { Component, OnInit, TemplateRef, ViewChild, ElementRef } from '@angular/core';
import moment from 'moment';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { ConfirmationService } from 'primeng/api';
import { Event, DashboardEvent, DashboardChart, UserGroup, SensorGroup, DashboardEventLogCriteria, EventLogInfo, DashboardEventSelection, DashboardRequest, DashboardEventCondition, EventType, TimerEventType, TimingInterval, EventLogResult, ActionType, LogicOperator, SensorReadingType, UserAccessRole, DeviceCheckCriteria, Device, Sensor } from '@models';
import { TriggerService } from '../trigger-settings/trigger.service';
import { DashboardEventsService } from './dashboard.service';
import { UserService } from '../../shared/services/user.service';
import { SensorReadingsService } from '../sensor-readings/sensor-readings.service';
import { ChartFavoriteInfo } from '../../shared/models/ChartFavorite/chartfavoriteInfo.model';
import { SensorService } from '../../shared/services/sensor.service';
import { DashboardEventValue, DashboardInfo, EventConditionValue } from '../../shared/models/Dashboard/dashboardInfo.model';
import { DashboardChartFavoriteCharts } from '../../shared/models/Dashboard/dashboardChartFavoriteCharts.model';
import { ChartData } from '../../shared/models/Dashboard/chartData.model';
import { SensorReadingInfo } from '../../shared/models/EventLog/SensorReadingInfo.model';
import { ChartDetails } from '../../shared/models/ChartFavorite/chartDetails.model';
import { ActivatedRoute } from '@angular/router';
import { SensorGroupService } from '../../shared/services/sensorgroup.service';
import { EventMapper } from '../trigger-settings/trigger.mapping';
import { EditEventsAndActionsModalComponent, EditEventsAndActionsModalParams } from '../trigger-settings/edit-events-and-actions-modal/edit-events-and-actions-modal.component';
import { DeviceInfo } from '@models/Device/DeviceInfo';
import { DashboardEventLogHistory } from '../../shared/models/Dashboard/DashboardEventTriggerHistory.model';
import { AppComponent } from '../../app.component';
import { Message, MessageActionType, MessageType, AppComponentName } from '../../shared/models/Messages/message.model';
import { AppMessageService } from '../../shared/services/message.service';
import { forkJoin, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { SensorReadingCriteria2 } from '@models';
import { decodeDateRange, presetDateRange } from 'app/shared/classes/dateRangeCodec';
import { DeviceService } from '@services/device.service';
import { DeviceStats } from '@models/Device/DeviceStats.model';
import { Charting } from 'app/shared/classes/charting';
import { CommonShared } from 'app/shared/classes/common';
import { Authorization } from 'app/shared/classes/authorization';
import { ChangeLogNotesComponent, ChangeLogNotesParams } from '../messages/changelog-notes/changelognotes.components';
import { slice } from 'lodash';
import { ImageFavoriteService } from '@services/imageFavorite.service';
import { MapFavoriteService } from '@services/mapFavorite.service';
import { MapFavoriteInfo } from '@models/MapFavorite/mapFavoriteInfo.model';
import { ImageFavoriteInfo } from '@models/ImageFavorite/imageFavoriteInfo.model';
import { ImageFavoriteSize } from '@models/ImageFavorite/imageFavorite.enums';
import { ImageFavoriteGateway } from 'app/shared/components/image-favorite/image-favorite-edit-modal/image-favorite-edit-modal.component';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';


// One tile on the Favorites tab. key ("e:<eventId>", "c:<chartFavoriteId>",
// "i:<imageFavoriteId>", "m:<mapFavoriteId>") is what the dashboard's favoritesOrder stores.
interface FavoriteTile {
  key: string;
  kind: 'event' | 'chart' | 'image' | 'map';
  event?: DashboardEvent;
  chart?: DashboardChartFavoriteCharts;
  image?: ImageFavoriteInfo;
  map?: MapFavoriteInfo;
}


@Component({
  standalone: false,
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: [ './dashboard.component.scss' ]
})

export class DashboardComponent implements OnInit {

  @ViewChild('chartRef') chartRef: any;
  private charting = new Charting();
  public common = new CommonShared();
  public auth = new Authorization();

  modalDragOn: boolean = false;

  // When true, the inline "Create" wizard replaces the left list + right tabs.
  public wizardMode = false;
  // The chart favorite the wizard is editing (set from a chart tile's pencil);
  // null means the wizard is in create mode.
  public favoriteBeingEdited: ChartFavoriteInfo = null;
  // The image favorite the wizard is editing (set from an image tile's pencil).
  public imageFavoriteBeingEdited: ImageFavoriteInfo = null;
  // The map favorite the wizard is editing (set from a map tile's pencil).
  public mapFavoriteBeingEdited: MapFavoriteInfo = null;

  // Data the embedded/popup Events & Actions editor needs (loaded on startup).
  public editorDevices: DeviceInfo[] = [];
  public editorSensorGroups: SensorGroup[] = [];
  public editorGatewayNames: string[] = [];
  public editorEvaluateTimes: string[] = [];
  public editorIrrZones: string[] = [];
  private eventEditorDataLoaded = false;

  public associatedUserGroups: UserGroup[] = new Array<UserGroup>();
  public awaitAssociatedUserGroups = false;
  public userGroupsLoaded: boolean = false;
  public userGroups: UserGroup[] = [];
  public eventMapper = new EventMapper();

  public titleForDashboardModal = '';
  // One "Show Favorites Tab" checkbox drives includeChartsTab, includeImageFavoritesTab
  // and includeMapFavoritesTab (the combined tab shows if any is on).
  public includeFavoritesTab: boolean = true;
  public includeEventsTab: boolean = true;
  public includeIsalTab: boolean = false;
  public computeActionSumCountsForEvents: boolean = false;
  public dashboards: DashboardInfo[] = [];
  public selectedDashboard: DashboardInfo;

  public makeDashboard: DashboardRequest = {
    name :undefined,
    userName: undefined,
    id: undefined,
    chartFavoriteIds: new Array<number>(),
    imageFavoriteIds: new Array<number>(),
    mapFavoriteIds: new Array<number>(),
    eventIDs: new Array<number>(),
    userGroup: '',
    userGroupID: null,
    includeChartsTab: 1,
    includeEventsTab: 1,
    includeIsalTab: 0,
    includeImageFavoritesTab: 0,
    includeMapFavoritesTab: 0,
    computeActionSumCountsForEvents: 0
  };

  public dashboardName='';
  public dashboardsToDisplay: DashboardInfo[] = [];
  public dashboardConditionValues: DashboardEventValue[] = [];
  public recentConditionValues: EventConditionValue[] = [];
  public preEditObjectAsJSONString = '';
  public chartFavorites: ChartFavoriteInfo[] = [];
  public currentEventName='';
  public currentChartData: ChartData[] = [];

  // The clicked chart favorite's data for the popup modal's (full) eChart.
  public currentSensors: Sensor[] = [];
  public currentSensorReadingTypes: SensorReadingType[] = [];
  public currentSensorReadings: SensorReadingInfo[] = [];
  public currentSavedChartDetails: ChartDetails = null;
  public currentIncludeCalValues: boolean = true;
  public currentIncludeOrigValues: boolean = false;
  // Readings of the selected dashboard's chart favorites, by chart favorite id.
  private dashboardChartReadings = new Map<number, SensorReadingInfo[]>();
  public currentManualScaling: boolean = false;
  public currentScaleYMin: number = null;
  public currentScaleYMax: number = null;

  public updateFlag = false;
  public selectedEventLogHistory: DashboardEventLogHistory[] = [];
  public changeLogNotes = '';
  public username = 'unknown';
  public selectedUserGroup: UserGroup;
  public eventSelection: DashboardEventSelection[] = [];
  public eventsLoaded = false;
  public dashboardsLoaded = false;

  public events: Event[] = [];
  public sensorGroups: SensorGroup[] = [];
  public sensorDataTypes: SensorReadingType[] = [];

  public selectedDashboardChartDataLoaded: boolean = false;
  public selectedDashboardEventConditionValuesLoaded: boolean = false;
  public selectedDashboardEventLogsLoaded: boolean = false;
  public selectedDashboardBuildStarted: boolean = false;
  public selectedDashboardEventLogInfo: EventLogInfo[] = [];

  public generalStatsDeviceConnectivity: string[] = [];
  public generalStatsEventsWithNoLogs: string[] = [];
  public generalStatsRecentActionFails: string[] = [];
  public generalStatsEventsLeftOn: string[] = [];
  public generalStatsEventsLeftOnWaiting: boolean = false;

  public eventsSearch: string = '';
  public eventsSearchNote: string = '';
  public eventsDisplayed: DashboardEventSelection[] = [];
  public chartsSearch: string = '';
  public chartsSearchNote: string = '';
  public chartsDisplayed: DashboardChart[] = [];
  public imagesSearch: string = '';
  public imagesSearchNote: string = '';
  public imagesDisplayed: DashboardChart[] = [];
  public mapsSearch: string = '';
  public mapsSearchNote: string = '';
  public mapsDisplayed: DashboardChart[] = [];

  // Left-sidebar dashboard list: search text, the search-filtered view of
  // dashboardsToDisplay, the collapsed/expanded state of the sidebar, and the
  // scroll container the up/down arrow buttons scroll.
  public dashboardSearch: string = '';
  public dashboardsDisplayed: DashboardInfo[] = [];
  public sidebarCollapsed = false;
  @ViewChild('dashboardListScroll') dashboardListScroll: ElementRef<HTMLElement>;
  // The dashboard open in the edit/view modal. Editing is independent of the
  // loaded selection, so the modal reads from this (not selectedDashboard) and
  // never triggers a detail load.
  private editingDashboard: DashboardInfo = null;

  logModalRef: BsModalRef;
  modalRef: BsModalRef;

  config = {
    backdrop: false,
    ignoreBackdropClick: false
  };

  public userGroupconfig: any = {
    displayKey: 'name',
    search: true,
    height: '300px',
    placeholder: 'Select User Group',
    noResultsFound: 'No User Groups found!',
    searchOnKey: 'name'
  };

  triggerListCols = [
    { field: 'checkbox', header: '', width: '10%' },
    { field: 'name', header: 'Name', width: '90%' }
  ];

  chartListCols = [
    {field: 'checkbox', header: '', width: '10%'},
    {field: 'name', header: 'Name', width: '90%'}
  ];

  triggerHistoryCols = [
    {field: 'createdDate', header: 'Date', width: '22%'},
    {field: 'conditions', header: 'Condition(s)', width: '40%'},
    {field: 'actionResults', header: 'Action Results', width: '28%'},
    {field: 'ElapsedTime', header: 'Since(Hrs)', width: '10%'}
  ];

  public chartSelection: DashboardChart[] = [];
  // Favorite shown in the enlarged chart modal (loads its chart labels).
  public currentChartFavoriteId = 0;

  // Image favorites: the master list (tiles + the edit modal's selection rows)
  // and the gateways a dynamic favorite can use (wizard).
  public imageFavorites: ImageFavoriteInfo[] = [];
  public imageSelection: DashboardChart[] = [];
  public imageFavoriteGateways: ImageFavoriteGateway[] = [];
  public enlargedImageFavorite: ImageFavoriteInfo = null;
  public mapFavorites: MapFavoriteInfo[] = [];
  public mapSelection: DashboardChart[] = [];
  public enlargedMapFavorite: MapFavoriteInfo = null;
  public chartsLoaded = false;
  public dashboardEvents: DashboardEvent[] = [];
  public dashboardFinishedTasks = true;
  public buttonValue: string;

  public eventCols = [
    {field: 'eventName', header: 'Event Name'},
    {field: 'window', header: 'Window'},
    {field: 'eventConditions', header: 'Current Event Conditions'},
    {field: 'lastTriggeredDate', header: 'Last Action'},
    {field: 'elapsedTime', header: 'Time Since (hrs)'}
  ];

  public dashboardCharts: DashboardChartFavoriteCharts[] = [];
  public dashboardChartsWithoutEvents: DashboardChartFavoriteCharts[] = [];
  public chartDate: any;

  // Favorites & Results tile size (Small = current look). Persisted globally to
  // localStorage and clearable from the home page's "Clear Saved Page Settings".
  private static readonly FAVORITES_LAYOUT_STORAGE_KEY = 'DashboardFavoritesLayout';
  // Last-selected dashboard id and sidebar collapsed state, persisted to
  // localStorage so the page restores them on reload. Both are clearable from
  // the home page's "Clear Saved Page Settings" (home.component.ts).
  private static readonly LAST_SELECTED_STORAGE_KEY = 'DashboardLastSelected';
  private static readonly SIDEBAR_COLLAPSED_STORAGE_KEY = 'DashboardSidebarCollapsed';
  // Also sizes the image tiles (ImageFavoriteComponent uses the same widths).
  public favoritesLayoutSize: ImageFavoriteSize = 'Small';
  // Minimal charts (dashboard tiles) have a 200px .echart min-height floor, so
  // these heights render as-is: Medium matches Small; Large is 1.5x taller. Widths
  // are 2x (Medium) and 4x (Large) the Small width.
  private readonly favoritesLayoutSizes: { [size: string]: { width: string; chartHeight: string } } = {
    Small:  { width: '300px',  chartHeight: '200px' },
    Medium: { width: '600px',  chartHeight: '400px' },
    Large:  { width: '1200px', chartHeight: '800px' }
  };
  private get favoritesLayout(): { width: string; chartHeight: string } {
    return this.favoritesLayoutSizes[this.favoritesLayoutSize] ?? this.favoritesLayoutSizes.Small;
  }
  get tileWidth(): string { return this.favoritesLayout.width; }
  get tileChartHeight(): string { return this.favoritesLayout.chartHeight; }

  public view: any[] = [1200,700];
  public chartOptions: any = {
    showXAxis: true,
    showYAxis: true,
    gradient: false,
    showLegend: true,
    showXAxisLabel: true,
    xAxisLabel: 'Date-Time (Select range from the below scale)',
    showYAxisLabel: true,
    yAxisLabel:'Value',
    autoScale:true,
    scaleYMin: null,
    scaleYMax: null,
    legendTitle:'Sensors With Datatype',
    timeline: true,
    colorScheme: {
      domain: [ '#046dd6', '#800080', '#42f55a', '#ffc107', '#fa0f0f' ]
    }
  };

  public chartViewCard: any[] = [278,200];
  public chartOptionsCard: any = {
    showXAxis: false,
    showYAxis: true,
    gradient: false,
    showLegend: false,
    showXAxisLabel: false,
    xAxisLabel: 'Date-Time (Select Range from the below Scale)',
    showYAxisLabel: false,
    yAxisLabel:'Value',
    autoScale: true,
    scaleYMin: null,
    scaleYMax: null,
    legendTitle:'Sensors With Datatype',
    timeline: false,
    colorScheme: {
      domain: [ '#046dd6', '#800080', '#42f55a', '#ffc107', '#fa0f0f' ]
    }
  };

  public timeToEvaluteDisplay = '';
  public globalSwitch: boolean;
  public userNameTimer: any;
  public canUserViewIsal: boolean = false;

  constructor(public toastr: ToastrService,
    public modalService: BsModalService,
    public _userService: UserService,
    private confirmationService: ConfirmationService,
    private _triggerService: TriggerService,
    public _sensorReadingService: SensorReadingsService,
    public _sensorService: SensorService,
    private _dashboardEventsService: DashboardEventsService,
    public _sensorGroupService: SensorGroupService,
    public _deviceService: DeviceService,
    private route: ActivatedRoute,
    private global: AppComponent,
    public _appMessageService: AppMessageService,
    private _imageFavoriteService: ImageFavoriteService,
    private _mapFavoriteService: MapFavoriteService)
  {
    this.globalSwitch = global.globalSwitch;
  }


  ngOnInit() {
    this.restoreFavoritesLayoutSize();
    this.restoreSidebarCollapsed();

    this._userService.getCurrentUserEmailUsingAzureAD().subscribe(
      results => {

        this.username = results['value'];
        if (this.username != null && this.username != '') {
          this.startUp();
        }
      },
      err => {
        this.toastr.error('Error unable to read current user\'s info');
      });
  }


  private restoreFavoritesLayoutSize(): void {
    const saved = localStorage.getItem(DashboardComponent.FAVORITES_LAYOUT_STORAGE_KEY);
    if (saved === 'Small' || saved === 'Medium' || saved === 'Large') {
      this.favoritesLayoutSize = saved;
    }
  }


  onFavoritesLayoutSizeChange(): void {
    localStorage.setItem(DashboardComponent.FAVORITES_LAYOUT_STORAGE_KEY, this.favoritesLayoutSize);
  }


  // Sidebar starts expanded unless a prior collapse was saved in this browser.
  private restoreSidebarCollapsed(): void {
    this.sidebarCollapsed = localStorage.getItem(DashboardComponent.SIDEBAR_COLLAPSED_STORAGE_KEY) === 'true';
  }


  toggleSidebar(): void {
    this.sidebarCollapsed = !this.sidebarCollapsed;
    localStorage.setItem(DashboardComponent.SIDEBAR_COLLAPSED_STORAGE_KEY, String(this.sidebarCollapsed));
  }


  // Filters the access-filtered dashboard list by the search box text. Mirrors
  // the modal event/chart search (searchEventsTextChanged).
  dashboardSearchTextChanged(): void {
    const term = (this.dashboardSearch ?? '').toLowerCase().trim();
    this.dashboardsDisplayed = term === ''
      ? [...this.dashboardsToDisplay]
      : this.dashboardsToDisplay.filter(d => d.name && d.name.toLowerCase().includes(term));
  }


  // Scrolls the sidebar list by ~80% of its visible height (direction -1 up, 1 down).
  scrollDashboardList(direction: number): void {
    const el = this.dashboardListScroll?.nativeElement;
    if (el) {
      el.scrollBy({ top: direction * Math.round(el.clientHeight * 0.8), behavior: 'smooth' });
    }
  }


  // Row click selects the dashboard (same effect as the old dropdown change).
  selectDashboardRow(row: DashboardInfo): void {
    this.setDashboardSelection(row.id);
  }


  // Row pencil/eye icon: opens the edit/view modal for that dashboard without
  // loading it or changing what is displayed on the right.
  editDashboardRow(row: DashboardInfo, template: TemplateRef<any>): void {
    this.editDashboard(row, template);
  }


  // Row trash icon: deletes that dashboard without changing what is displayed,
  // unless the deleted dashboard is the one currently shown.
  deleteDashboardRow(row: DashboardInfo): void {
    this.deleteDashboard(row);
  }


  startUp() {
    this.getChartFavorites();
    this.getImageFavorites();
    this.getMapFavorites();
    this.getAssociatedUserGroups();
    this.getSensorDatatypesWithIDs();
    this.loadEventEditorData();
    this.startTimer();
  }

  // Load the data the Events & Actions editor needs when editing an event from
  // the dashboard edit modal (devices + gateway names, sensor groups with reading
  // types; evaluate-times and irrigation zones generated locally).
  private loadEventEditorData(): void {
    if (this.eventEditorDataLoaded) { return; }
    this.eventEditorDataLoaded = true;

    for (let h = 0; h < 24; h++) {
      this.editorEvaluateTimes.push(this.pad2(h) + ':15');
      this.editorEvaluateTimes.push(this.pad2(h) + ':45');
    }
    for (let i = 0; i < 30; i++) {
      this.editorIrrZones.push(i.toString());
    }

    this._deviceService.getDevices().subscribe(
      results => {
        if (results != null) {
          this.editorDevices = results;
          this.editorGatewayNames = [];
          this.imageFavoriteGateways = [];
          this.editorDevices.forEach(d => {
            const owned = d.userName === this.username || this.associatedUserGroups.findIndex(u => u.id === d.userGroupId) > -1;
            if (owned && d.serialNumber !== '') { this.editorGatewayNames.push(d.name); }
            // Gateways with cameras can supply a dynamic image favorite background.
            if (owned && d.serialNumber !== '' && d.deviceCameras != undefined && d.deviceCameras.length > 0) {
              this.imageFavoriteGateways.push({ serialNumber: d.serialNumber, name: d.name });
            }
          });
        }
      },
      () => { /* non-fatal: gateway dropdowns just stay empty */ }
    );

    this._sensorGroupService.getSensorGroupWithSensorsAndReadingTypes().subscribe(
      results => { if (results != null) { this.editorSensorGroups = results; } },
      () => { /* non-fatal */ }
    );
  }

  private pad2(n: number): string {
    return (n < 10 ? '0' : '') + n;
  }


  setDragOn(drag: boolean) {
    this.modalDragOn = drag;

    if (drag) {
      setTimeout(() => {
        this.modalDragOn = false;
      },3000);
    }
  }


  getDashboards(dashboardID: number, preserveSelection: boolean = false) {
    this._dashboardEventsService.getDashboards().subscribe(
      results => {
        if (results != null) {
          this.dashboardsLoaded = true;
          this.dashboards = JSON.parse(JSON.stringify(results));

          this.dashboards.forEach(e => {
            this.auth.mapUserAccessForDashboard(e, this.globalSwitch, this.username, this.userGroups);
          });

          for (const dashboard of this.dashboards) {
            if (dashboard.userGroupId <= 0) {
              dashboard.toGroupBy = dashboard.userName;
            } else {
              dashboard.toGroupBy = dashboard.userGroup;
            }
          }

          this.sortDashboards(this.dashboards);

          if (preserveSelection) {
            // Post-edit list refresh: keep whatever is displayed. Re-point the
            // current selection to the refreshed object (so the list/name reflect
            // the edit) without reloading its detail, and skip any auto-selection.
            if (this.selectedDashboard != undefined) {
              const refreshed = this.dashboards.find(d => d.id === this.selectedDashboard.id);
              if (refreshed != undefined) {
                this.selectedDashboard = refreshed;
              }
            }
            this.updateDashboardsToDisplay(this.globalSwitch);
          } else {
            this.route.params.subscribe(params => {
              if (params['id']) {
                (1);
                this.setDashboardSelection(params['id']);
              }
            });

            if (dashboardID != null && dashboardID > 0) {
              this.setDashboardSelection(dashboardID);
            }

            this.updateDashboardsToDisplay(this.globalSwitch);

            // On the initial load (no route-param id and no explicit re-select id),
            // restore the last dashboard this browser had selected, if it is still
            // visible to the user. A route-param id or a post-create/update id wins.
            const hasRouteId = this.route.snapshot.params['id'] != undefined;
            if (!hasRouteId && (dashboardID == undefined || dashboardID <= 0)) {
              const cachedId = Number(localStorage.getItem(DashboardComponent.LAST_SELECTED_STORAGE_KEY));
              if (cachedId > 0 && this.dashboardsToDisplay.some(d => d.id === cachedId)) {
                this.setDashboardSelection(cachedId);
              }
            }
          }

        } else {
          this.toastr.warning('No dashboards found.');
        }
        return;
      },
      err => {
        this.toastr.error('Error occurred while retrieving current display.');
      });
  }


  // Alphabetical by name for the sidebar's flat list (case-insensitive, numbers in
  // natural order), the same comparison the favorites lists use.
  sortDashboards(dashboards: DashboardInfo[]) {
    dashboards.sort((a, b) => (a.name ?? '').toString().localeCompare((b.name ?? '').toString(), 'en', { numeric: true, sensitivity: 'base' }));
  }


  updateDashboardsToDisplay(showAll: boolean): void {
    this.dashboardsToDisplay = [];
    this.dashboards.forEach(dashboard => {
      if (dashboard.userFeatureAccess['ViewListing']) {
        this.dashboardsToDisplay.push(dashboard);
      }
    });
    this.dashboardSearchTextChanged();   // keep the sidebar's filtered list in sync
  }


  // Loads the master image-favorite list. imageSelection (the edit modal's rows)
  // is rebuilt unless rebuildSelection is false (keeps the open modal's checks).
  getImageFavorites(onDone?: () => void, rebuildSelection: boolean = true): void {
    this._imageFavoriteService.getImageFavorites().subscribe(
      results => {
        this.imageFavorites = (results ?? []).sort((a, b) => a.name.toString().localeCompare(b.name.toString(), 'en', { numeric: true }));
        this.applyFavoriteAccess();
        if (rebuildSelection) {
          this.imageSelection = this.imageFavorites.map(f => ({ id: f.id, name: f.name, checked: false }));
        }
        if (onDone) { onDone(); }
      },
      err => {
        this.toastr.error('Error occurred while retrieving image favorites.');
        if (onDone) { onDone(); }
      });
  }


  // Loads the master map-favorite list. mapSelection (the edit modal's rows) is rebuilt
  // unless rebuildSelection is false (keeps the open modal's checks).
  getMapFavorites(onDone?: () => void, rebuildSelection: boolean = true): void {
    this._mapFavoriteService.getMapFavorites().subscribe(
      results => {
        this.mapFavorites = (results ?? []).sort((a, b) => a.name.toString().localeCompare(b.name.toString(), 'en', { numeric: true }));
        this.applyFavoriteAccess();
        if (rebuildSelection) {
          this.mapSelection = this.mapFavorites.map(f => ({ id: f.id, name: f.name, checked: false }));
        }
        if (onDone) { onDone(); }
      },
      err => {
        this.toastr.error('Error occurred while retrieving map favorites.');
        if (onDone) { onDone(); }
      });
  }


  // Edit rights for the tiles' pencils (owner, admin, or full read/write on the
  // favorite's group). Re-run whenever any favorites list or the user groups
  // load, since they arrive in any order.
  private applyFavoriteAccess(): void {
    if (!this.userGroupsLoaded) {
      return;
    }
    this.chartFavorites.forEach(c => this.auth.mapUserAccessForChart(c, this.globalSwitch, this.username, this.userGroups));
    this.imageFavorites.forEach(f => this.auth.mapUserAccessForImageFavorite(f, this.globalSwitch, this.username, this.userGroups));
    this.mapFavorites.forEach(f => this.auth.mapUserAccessForMapFavorite(f, this.globalSwitch, this.username, this.userGroups));
  }


  canEditChartFavorite(chartFavoriteId: number): boolean {
    const favorite = this.chartFavorites.find(c => c.id == chartFavoriteId);
    return favorite?.userFeatureAccess?.['EditChart'] === true;
  }


  canEditImageFavorite(imageFavorite: ImageFavoriteInfo): boolean {
    return imageFavorite.userFeatureAccess?.['EditImageFavorite'] === true;
  }


  // The selected dashboard's image favorites, in the dashboard's order.
  get selectedDashboardImageFavorites(): ImageFavoriteInfo[] {
    const ids = this.selectedDashboard?.imageFavoriteIds ?? [];
    return ids.map(id => this.imageFavorites.find(f => f.id === id)).filter(f => f != undefined);
  }


  trackImageFavoriteById(_index: number, imageFavorite: ImageFavoriteInfo): number {
    return imageFavorite.id;
  }


  canEditMapFavorite(mapFavorite: MapFavoriteInfo): boolean {
    return mapFavorite.userFeatureAccess?.['EditMapFavorite'] === true;
  }


  // The selected dashboard's map favorites, in the dashboard's order.
  get selectedDashboardMapFavorites(): MapFavoriteInfo[] {
    const ids = this.selectedDashboard?.mapFavoriteIds ?? [];
    return ids.map(id => this.mapFavorites.find(f => f.id === id)).filter(f => f != undefined);
  }


  showsFavoritesTab(dashboard: DashboardInfo): boolean {
    return dashboard?.includeChartsTab == 1 || dashboard?.includeImageFavoritesTab == 1 || dashboard?.includeMapFavoritesTab == 1;
  }


  // The Favorites tab's tiles (event, chart-only, image and map), intermixed. Tiles in
  // the dashboard's saved favoritesOrder come first in that order; any others
  // follow in the default order (events, charts, images, then maps). Recomputed
  // from the live lists so refreshes show up; trackBy keeps the DOM stable.
  get favoriteTiles(): FavoriteTile[] {
    const tiles: FavoriteTile[] = [
      ...this.dashboardEvents.map(event => ({ key: 'e:' + event.eventId, kind: 'event' as const, event })),
      ...this.dashboardChartsWithoutEvents.map(chart => ({ key: 'c:' + chart.chartFavoriteID, kind: 'chart' as const, chart })),
      ...this.selectedDashboardImageFavorites.map(image => ({ key: 'i:' + image.id, kind: 'image' as const, image })),
      ...this.selectedDashboardMapFavorites.map(map => ({ key: 'm:' + map.id, kind: 'map' as const, map }))
    ];

    const rank = new Map<string, number>();
    this.savedFavoritesOrder.forEach((key, i) => rank.set(key, i));
    const unranked = tiles.length;
    // Stable sort: unranked tiles keep their default relative order at the end.
    return tiles
      .map((tile, i) => ({ tile, i, r: rank.get(tile.key) ?? unranked }))
      .sort((a, b) => a.r - b.r || a.i - b.i)
      .map(x => x.tile);
  }


  // Parsed selectedDashboard.favoritesOrder (cached by source string).
  private get savedFavoritesOrder(): string[] {
    const source = this.selectedDashboard?.favoritesOrder ?? '';
    if (source !== this.parsedFavoritesOrderSource) {
      this.parsedFavoritesOrderSource = source;
      try {
        const keys = source === '' ? [] : JSON.parse(source);
        this.parsedFavoritesOrder = Array.isArray(keys) ? keys.filter(k => typeof k === 'string') : [];
      } catch {
        this.parsedFavoritesOrder = [];
      }
    }
    return this.parsedFavoritesOrder;
  }
  private parsedFavoritesOrderSource = '';
  private parsedFavoritesOrder: string[] = [];


  get canReorderFavorites(): boolean {
    return this.selectedDashboard?.userFeatureAccess?.['EditDashboard'] === true;
  }


  trackFavoriteTileByKey(_index: number, tile: FavoriteTile): string {
    return tile.key;
  }


  // A tile was dropped (dragged by its title bar): apply the new order locally,
  // then save it for everyone; on failure, put the previous order back.
  onFavoriteTileDropped(drop: CdkDragDrop<FavoriteTile[]>): void {
    const dashboard = this.selectedDashboard;
    if (dashboard == undefined || drop.previousIndex === drop.currentIndex) {
      return;
    }
    const keys = this.favoriteTiles.map(t => t.key);
    moveItemInArray(keys, drop.previousIndex, drop.currentIndex);

    const previousOrder = dashboard.favoritesOrder;
    dashboard.favoritesOrder = JSON.stringify(keys);

    this._dashboardEventsService.updateFavoritesOrder(dashboard.id, keys, this.username).subscribe(
      result => {
        if (result == 'success') {
          this.createMessageData(MessageActionType.Edited, { userGroupID: dashboard.userGroupId } as DashboardRequest,
            'FavoritesOrder changed', dashboard.name, '');
          this.toastr.success('Favorites order saved');
        }
      },
      err => {
        dashboard.favoritesOrder = previousOrder;
        this.toastr.error('Error occurred while saving the favorites order.');
      });
  }


  showDashboardImageFavorite(template: TemplateRef<any>, imageFavorite: ImageFavoriteInfo): void {
    this.enlargedImageFavorite = imageFavorite;
    this.modalRef = this.modalService.show(template, { animated: false, backdrop: false, ignoreBackdropClick: false, class: 'resizable-favorite-dialog' });
  }


  showDashboardMapFavorite(template: TemplateRef<any>, mapFavorite: MapFavoriteInfo): void {
    this.enlargedMapFavorite = mapFavorite;
    this.modalRef = this.modalService.show(template, { animated: false, backdrop: false, ignoreBackdropClick: false, class: 'resizable-favorite-dialog' });
  }


  // Loads the master chart-favorite metadata list. Pass onDone to sequence work
  // that depends on the refreshed list (e.g. reloading a dashboard whose tiles
  // look favorites up in this.chartFavorites). chartSelection is rebuilt from
  // scratch so a re-call does not duplicate entries.
  getChartFavorites(onDone?: () => void, rebuildSelection: boolean = true): void {
    this._sensorReadingService.getChartFavorites().subscribe(
      results => {
        if (results != null) {
          this.chartFavorites = results;
          this.chartFavorites = this.chartFavorites.sort((a, b) => a.name.toString().localeCompare(b.name.toString(), 'en', { numeric: true }));
          if (rebuildSelection) {
            this.chartSelection = [];
          }
          this.chartFavorites.forEach(chartFavorite => {
            // A favorite saved with only individual sensors has no scalar sensorGroup.
            if (chartFavorite.sensorGroup) {
              chartFavorite.sensorGroup.sensors = chartFavorite.sensors;
            }
            if (rebuildSelection) {
              this.chartSelection.push( {id: chartFavorite.id, name: chartFavorite.name, checked: false} );
            }
          });
          this.applyFavoriteAccess();
        } else {
          this.toastr.warning('No Chartfavorites found.');
        }
        if (onDone) { onDone(); }
        return;
      },
      err => {
        this.toastr.error('Error occurred while retrieving current display.');
        if (onDone) { onDone(); }   // still proceed so a dependent reload isn't blocked
      });
  }


  getEvents(): void {
    this._triggerService.getEvents('Loading events ...').subscribe(
      results => {
        if (results != null) {
          this.events = this.eventMapper.mapEventInfos2Events(results);
          this.eventsLoaded = true;

          this.events.forEach(e => {
            this.eventSelection.push({id: e.id, name: e.name, checked: false});
            e.sensorConditions.forEach(s => s.sensorGroup = this.sensorGroups.find(x => x.id == s.sensorGroupID));
            this.auth.mapUserAccessForEvent(e, this.globalSwitch, this.username, this.userGroups);
          });

          this.eventSelection = this.eventSelection.sort((a, b) => a.name.toString().localeCompare(b.name.toString(), 'en', { numeric: true }));
          this.startTimerEventWindowCheck();
          this.getEventIdsWithNoRecentEventLog(this.events);
          this.getEventIdsForActionsWithNegativeResponse(this.events);
          this.getIrrigationEventsLeftOn();
        } else {
          this.toastr.warning('No events found');
        }
        return;
      },
      err => {
        this.toastr.error('Error occurred while retrieving current display');
      });
  }


  getSensorGroups(): void {
    this._sensorGroupService.getSensorGroups().subscribe(
      results => {
        if (results != null) {
          this.sensorGroups = results;
          this.getEvents();
        }
        else {
          this.toastr.warning('No Sensor Groups found.');
        }
        return;
      },
      err => {
        this.toastr.error('Error occurred while retrieving current display.');
      });
  }


  getUserGroups(): void {
    this.userGroupsLoaded = false;
    this._userService.getUserGroups().subscribe(
      results => {
        if (results != null) {
          this.userGroups = results;
          this.userGroupsLoaded = true;
          this.applyFavoriteAccess();
          this.getDashboards(null);
          this.getSensorGroups();
          this.getUserRoleForISAL();
        } else {
          this.toastr.warning('No user groups found');
        }
        return;
      },
      err => {
        this.toastr.error('Error occurred while retrieving all user groups');
      });
  }


  getUserRoleForISAL() {
    this.canUserViewIsal = (this.associatedUserGroups.findIndex(x => x.name.toLowerCase() == "isal") > -1) ? true : false;
  }


  getAssociatedUserGroups(): void {
    this._userService.getAssociatedUserGroups(this.username).subscribe(
      results => {
        if (results != null) {
          this.awaitAssociatedUserGroups = true;
          this.associatedUserGroups = results;
        }
        this.getUserGroups();
        this.getDevices();
      },
      err => {
        this.toastr.error('Error occurred while retrieving current display.');
      });
  }


  getDevices(): void{
    this._deviceService.getDevices().subscribe(
      results => {
        if (results != null) {
          this.getDeviceConnectivityStats(results);
        } else {
          this.toastr.warning('Unable to get gateway stats');
        }
        return;
      },
      err => {
        this.toastr.error('Error: Unable to get gateway stats');
      });
  }


  getDeviceConnectivityStats(devices: Device[]) {
    var myDeviceIds: number[] = [];
    devices.forEach(d => {
      var associatedUserGroup = this.associatedUserGroups.find(u => u.id == d.userGroupId);
      if ((this.username.toLowerCase() === d.userName.toLowerCase() || associatedUserGroup != undefined) && d.serialNumber != '') {
        myDeviceIds.push(d.id);
      }
    });

    var dataCriteria: DeviceCheckCriteria = {
      pastNumberOfHoursToEvaluate: 24,
      deviceIds: myDeviceIds
    }

    this._deviceService.getDeviceConnectivityStats(dataCriteria).subscribe(
      results => {
        if (results != null) {
          var stats: DeviceStats[] = results;
          this.generalStatsDeviceConnectivity = [];
          devices.forEach(x => {
            var value = stats.filter(y => y.id == x.id && y.timePeriod == 1).map(z => z.value);
            if (value != undefined && value.length > 0 && value[0] < 90) {
              this.generalStatsDeviceConnectivity.push(x.name);
            }
          });
        } else {
          this.toastr.warning('No gateway devices found.');
        }
        return;
      },
      err => {
        this.toastr.error('Error occurred while retrieving gateways.');
      });
  }


  getEventIdsWithNoRecentEventLog(events: Event[]) {
    var myEventIds: number[] = [];
    events.forEach(d => {
      var associatedUserGroup = this.associatedUserGroups.find(u => u.id == d.userGroupID);
      if ((this.username.toLowerCase() === d.userName.toLowerCase() || associatedUserGroup != undefined)) {
        myEventIds.push(d.id);
      }
    });

    this._dashboardEventsService.getEventIdsWithNoRecentEventLog(myEventIds).subscribe(
      results => {
        if (results != null) {
          var eventIds: number[] = results;
          if (eventIds.length > 0) {
            this.generalStatsEventsWithNoLogs = [];
            eventIds.forEach(x => {
              var event = events.find(y => y.id == x);
              if (event != undefined) {
                this.generalStatsEventsWithNoLogs.push(event.name);
              }
            });
          }
        } else {
          this.toastr.warning('No event log stats found.');
        }
        return;
      },
      err => {
        this.toastr.error('Error: No event log stats found.');
      });
  }


  getEventIdsForActionsWithNegativeResponse(events: Event[]) {
    var myEventIds: number[] = [];
    events.forEach(d => {
      var associatedUserGroup = this.associatedUserGroups.find(u => u.id == d.userGroupID);
      if ((this.username.toLowerCase() === d.userName.toLowerCase() || associatedUserGroup != undefined)) {
        myEventIds.push(d.id);
      }
    });

    this._dashboardEventsService.getEventIdsForActionsWithNegativeResponse(myEventIds).subscribe(
      results => {
        if (results != null) {
          var eventIds: number[] = results;
          if (eventIds.length > 0) {
            this.generalStatsRecentActionFails = [];
            eventIds.forEach(x => {
              var event = events.find(y => y.id == x);
              if (event != undefined) {
                this.generalStatsRecentActionFails.push(event.name);
              }
            });
          }
        } else {
          this.toastr.warning('No event log stats found.');
        }
        return;
      },
      err => {
        this.toastr.error('Error: No event log stats found.');
      });
  }


  getIrrigationEventsLeftOn() {
    this.generalStatsEventsLeftOnWaiting = true;
    this._dashboardEventsService.getIrrigationEventsLeftOn().subscribe(
      results => {
        if (results != null) {
          var response: number[] = results;
          this.generalStatsEventsLeftOn = [];

          response.forEach(eventId => {
            var event = this.events.find(y => y.id == eventId);
            if (event != undefined && event.userFeatureAccess['ViewListing']) {
              this.generalStatsEventsLeftOn.push(event.name);
            }
          });
        }
        this.generalStatsEventsLeftOnWaiting = false;
      },
      err => {
        this.toastr.error('Error while analayzing Events & Actions for anomalies.');
        this.generalStatsEventsLeftOnWaiting = false;
      });
  }


  getSensorDatatypesWithIDs(): void {
    this._sensorService.getSensorDatatypesWithIDs().subscribe(
      results => {
        if (results != null) {
          this.sensorDataTypes = results;
          this.common.sortArrayByTypeParm(this.sensorDataTypes);
        } else {
          this.toastr.warning('No sensor data types found.');
        }
        return;
      },
      err => {
        this.toastr.error('Error occurred while retrieving sensor data types.');
      });
  }


  // Enter the inline create wizard (replaces the old single-page create modal
  // for the Create button; the per-row Edit/View pencil still uses the modal).
  enterCreateWizard(): void {
    this.favoriteBeingEdited = null;
    this.imageFavoriteBeingEdited = null;
    this.mapFavoriteBeingEdited = null;
    this.wizardMode = true;
  }

  // Open the wizard in edit mode for an image favorite (pencil on its tile).
  editImageFavoriteRow(imageFavoriteId: number): void {
    const imageFavorite = this.imageFavorites.find(f => f.id == imageFavoriteId);
    if (imageFavorite == undefined) {
      this.toastr.warning('Image favorite not found.');
      return;
    }
    this.favoriteBeingEdited = null;
    this.mapFavoriteBeingEdited = null;
    this.imageFavoriteBeingEdited = imageFavorite;
    this.wizardMode = true;
  }

  // Open the wizard in edit mode for a map favorite (pencil on its tile).
  editMapFavoriteRow(mapFavoriteId: number): void {
    const mapFavorite = this.mapFavorites.find(f => f.id == mapFavoriteId);
    if (mapFavorite == undefined) {
      this.toastr.warning('Map favorite not found.');
      return;
    }
    this.favoriteBeingEdited = null;
    this.imageFavoriteBeingEdited = null;
    this.mapFavoriteBeingEdited = mapFavorite;
    this.wizardMode = true;
  }

  // Open the wizard in edit mode for a chart favorite (pencil on its tile).
  editChartFavoriteRow(chartFavoriteId: number): void {
    const favorite = this.chartFavorites.find(c => c.id == chartFavoriteId);
    if (favorite == undefined) {
      this.toastr.warning('Chart favorite not found.');
      return;
    }
    this.imageFavoriteBeingEdited = null;
    this.mapFavoriteBeingEdited = null;
    this.favoriteBeingEdited = favorite;
    this.wizardMode = true;
  }

  // Open the full Events & Actions editor (the same component shown in the
  // Notification wizard's right pane) for an event clicked (pencil) in the
  // dashboard edit modal. It saves itself via its own Update button; this layers
  // it on top of the dashboard edit modal and refreshes events when it closes.
  editEventRow(eventId: number): void {
    const event = this.events.find(e => e.id == eventId);
    if (event == undefined) {
      this.toastr.warning('Event not found.');
      return;
    }
    // Edit a deep clone so a Cancel doesn't mutate the dashboard's copy (same as
    // trigger-settings.cloneEvent).
    const clone: Event = JSON.parse(JSON.stringify(event));
    const selectedUserGroup = this.associatedUserGroups.find(u => u.id == event.userGroupID)
      || this.associatedUserGroups.find(u => u.id == -1);

    const params: EditEventsAndActionsModalParams = {
      events: this.events,
      event: clone,
      changeLogNotes: '',
      username: this.username,
      selectedUserGroup: selectedUserGroup,
      preEditObjectAsJSONString: JSON.stringify(event),
      eventTitle: event.name,
      associatedUserGroups: this.associatedUserGroups,
      evaluateTimes: this.editorEvaluateTimes,
      sensorDataTypes: this.sensorDataTypes,
      sensorGroups: this.editorSensorGroups,
      IrrDestinationDDOptions: this.editorGatewayNames,
      CamGatewayDDOptions: this.editorGatewayNames,
      IrrZoneDDOptions: this.editorIrrZones,
      globalWaterSchedules: [],
      buttonValue: 'Update',
      devices: this.editorDevices,
      stopEventAction: () => {},
      userGroups: this.userGroups,
      actionQueues: []
    };

    const ref = this.modalService.show(EditEventsAndActionsModalComponent, {
      animated: false, backdrop: false, ignoreBackdropClick: true, class: 'edit-events-popup', initialState: params
    });
    if (ref.onHidden != undefined) {
      const sub = ref.onHidden.subscribe(() => {
        this.refreshEventsAfterEdit();
        sub.unsubscribe();
      });
    }
  }

  // Reload the master event list after an event is edited so names/definitions
  // are fresh. eventSelection is rebuilt from scratch (getEvents pushes to it) to
  // avoid duplicate rows in the dashboard edit modal.
  private refreshEventsAfterEdit(): void {
    this.eventSelection = [];
    this.getEvents();
  }

  onWizardCancelled(): void {
    this.wizardMode = false;
    this.favoriteBeingEdited = null;
    this.imageFavoriteBeingEdited = null;
    this.mapFavoriteBeingEdited = null;
  }

  // Called when the wizard finishes a CREATE (new favorite + new/updated dashboard).
  // Refresh the master chart-favorite list BEFORE reloading the dashboard: the
  // dashboard's tiles look each favorite up in this.chartFavorites, so a
  // just-created favorite must be present first (otherwise its tile is skipped
  // until a full page reload). Sequence them so the list is in place first.
  onWizardCreated(dashboardId: number): void {
    this.wizardMode = false;
    this.favoriteBeingEdited = null;
    this.imageFavoriteBeingEdited = null;
    this.mapFavoriteBeingEdited = null;
    this.getImageFavorites();
    // The map favorites must be in place before the dashboard reload, like the chart
    // favorites: a tile is skipped while its favorite is missing from the master list.
    this.getMapFavorites(() => this.getChartFavorites(() => this.getDashboards(dashboardId)));
  }

  // Called when the wizard finishes a map favorite EDIT. Reload the favorites (new
  // objects, so displayed tiles reload their readings, view and labels) without
  // rebuilding the edit modal's selection, and patch the edited row's name.
  onMapFavoriteUpdated(): void {
    this.wizardMode = false;
    const editedId = this.mapFavoriteBeingEdited != null ? this.mapFavoriteBeingEdited.id : null;
    this.mapFavoriteBeingEdited = null;
    this.getMapFavorites(() => {
      const updated = this.mapFavorites.find(f => f.id == editedId);
      if (updated != undefined) {
        const selRow = this.mapSelection.find(r => r.id == editedId);
        if (selRow != undefined) { selRow.name = updated.name; }
        const dispRow = this.mapsDisplayed.find(r => r.id == editedId);
        if (dispRow != undefined) { dispRow.name = updated.name; }
      }
    }, false);
  }

  // Called when the wizard finishes an image favorite EDIT. Reload the favorites
  // (new objects, so displayed tiles reload their image + labels) without
  // rebuilding the edit modal's selection, and patch the edited row's name.
  onImageFavoriteUpdated(): void {
    this.wizardMode = false;
    const editedId = this.imageFavoriteBeingEdited != null ? this.imageFavoriteBeingEdited.id : null;
    this.imageFavoriteBeingEdited = null;
    this.getImageFavorites(() => {
      const updated = this.imageFavorites.find(f => f.id == editedId);
      if (updated != undefined) {
        const selRow = this.imageSelection.find(r => r.id == editedId);
        if (selRow != undefined) { selRow.name = updated.name; }
        const dispRow = this.imagesDisplayed.find(r => r.id == editedId);
        if (dispRow != undefined) { dispRow.name = updated.name; }
      }
    }, false);
  }

  // Called when the wizard finishes an EDIT (favorite updated in place). Refresh
  // the master favorites list (so tiles use the new definition) WITHOUT rebuilding
  // the edit modal's selection (preserving its checks) and patch the edited row's name.
  onFavoriteUpdated(): void {
    this.wizardMode = false;
    const editedId = this.favoriteBeingEdited != null ? this.favoriteBeingEdited.id : null;
    this.favoriteBeingEdited = null;
    this.getChartFavorites(() => {
      if (editedId != null) {
        const updated = this.chartFavorites.find(c => c.id == editedId);
        if (updated != undefined) {
          const selRow = this.chartSelection.find(r => r.id == editedId);
          if (selRow != undefined) { selRow.name = updated.name; }
          const dispRow = this.chartsDisplayed.find(r => r.id == editedId);
          if (dispRow != undefined) { dispRow.name = updated.name; }
        }
      }
      // Rebuild the currently-displayed dashboard's chart tiles with the updated
      // favorite definition. Reset the build guard so checkReadyToBuildDashboard
      // runs again, and reload only the chart data (chartSelection is untouched).
      if (this.selectedDashboard != undefined) {
        this.selectedDashboardBuildStarted = false;
        this.getSelectedDashboardChartFavorites();
      }
    }, false);
  }


  prepNewDashboard(template: TemplateRef<any>) {
    this.editingDashboard = null;
    this.updateFlag = false;
    this.buttonValue = 'Create';
    this.titleForDashboardModal = 'New Dashboard';
    this.changeLogNotes = '';
    // Like editing, opening the modal doesn't change which dashboard is displayed;
    // createDashboard() switches to the new one once it saves.
    this.dashboardName = '';
    this.includeFavoritesTab = true;
    this.includeEventsTab = true;
    this.includeIsalTab = false;
    this.computeActionSumCountsForEvents = false;
    this.modalRef = this.modalService.show(template, { animated: false, backdrop: false, ignoreBackdropClick: true });
    this.clearTriggerSelection();
    this.clearChartSelection();
    this.clearImageSelection();
    this.clearMapSelection();
    // Show every row: a search left over from an earlier edit would otherwise hide some.
    this.eventsSearch = '';
    this.searchEventsTextChanged();
    this.chartsSearch = '';
    this.searchChartsTextChanged();
    this.imagesSearch = '';
    this.searchImagesTextChanged();
    this.mapsSearch = '';
    this.searchMapsTextChanged();
    this.setUserGroupsSelection();
  }


  editDashboard(dashboard: DashboardInfo, template: TemplateRef<any>) {
    this.editingDashboard = dashboard;
    this.updateFlag = true;
    this.buttonValue = 'Update';
    this.titleForDashboardModal = 'Edit Dashboard';
    this.changeLogNotes = '';
    this.dashboardName = dashboard.name;
    this.includeFavoritesTab = this.showsFavoritesTab(dashboard);
    this.includeEventsTab = dashboard.includeEventsTab == 1 ? true : false;
    this.includeIsalTab = dashboard.includeIsalTab == 1 ? true : false;
    this.computeActionSumCountsForEvents = dashboard.computeActionSumCountsForEvents == 1 ? true : false;
    this.setChartSelection();
    this.setImageSelection();
    this.setMapSelection();
    this.setTriggerSelection();
    this.setUserGroupsSelection();
    this.preEditObjectAsJSONString = JSON.stringify(dashboard);
    this.modalRef = this.modalService.show(template, { animated: false, backdrop: false, ignoreBackdropClick: true });
  }


  // Pre-check the dashboard's chart favorites from the ids carried on the row
  // (chartFavoriteIds), so the modal populates without loading the dashboard.
  setChartSelection(): void {
    if (this.chartSelection.length > 0 && this.editingDashboard != undefined && this.editingDashboard.chartFavoriteIds.length > 0){
      this.editingDashboard.chartFavoriteIds.forEach(chartId => {
        const chart = this.chartSelection.find( e => e.id == chartId);
        if (chart != undefined) {
          chart.checked = true;
        }
      });

      this.chartSelection = [...this.chartSelection];
      this.chartsSearch = '';
      this.searchChartsTextChanged();
    }
  }


  // Pre-check the dashboard's image favorites (same approach as setChartSelection).
  setImageSelection(): void {
    this.clearImageSelection();
    (this.editingDashboard?.imageFavoriteIds ?? []).forEach(imageFavoriteId => {
      const image = this.imageSelection.find(e => e.id == imageFavoriteId);
      if (image != undefined) {
        image.checked = true;
      }
    });
    this.imageSelection = [...this.imageSelection];
    this.imagesSearch = '';
    this.searchImagesTextChanged();
  }


  // Pre-check the dashboard's map favorites (same approach as setImageSelection).
  setMapSelection(): void {
    this.clearMapSelection();
    (this.editingDashboard?.mapFavoriteIds ?? []).forEach(mapFavoriteId => {
      const map = this.mapSelection.find(e => e.id == mapFavoriteId);
      if (map != undefined) {
        map.checked = true;
      }
    });
    this.mapSelection = [...this.mapSelection];
    this.mapsSearch = '';
    this.searchMapsTextChanged();
  }


  setTriggerSelection(): void {
    if (this.eventSelection.length > 0 && this.editingDashboard != undefined && this.editingDashboard.eventIds.length > 0){
      this.editingDashboard.eventIds.forEach(triggerId => {
        const trigger = this.eventSelection.find( e => e.id == triggerId);
        if (trigger != undefined) {
          trigger.checked = true;
        }
      });

      this.eventSelection = [...this.eventSelection];
      this.eventsSearch = '';
      this.searchEventsTextChanged();
    }
  }

  setUserGroupsSelection(): void {
    if (this.updateFlag && this.editingDashboard != undefined && this.editingDashboard.userGroupId != null && this.editingDashboard.userGroupId > 0) {
      const userGroup = this.associatedUserGroups.find(u => u.id == this.editingDashboard.userGroupId);
      if (userGroup) {
        this.selectedUserGroup = userGroup;
      } else {
        this.selectedUserGroup = this.associatedUserGroups.find(u => u.id == -1);
      }
    } else {
      this.selectedUserGroup = this.associatedUserGroups.find(u => u.id == -1);
    }
  }


  clearDashboardSelection(): void{
    this.selectedDashboard = undefined;
    this.dashboardName = undefined;
    this.dashboardEvents = [];
    this.dashboardCharts = [];
    this.dashboardChartsWithoutEvents = [];

  }


  clearTriggerSelection(): void {
    if (this.eventSelection.length > 0) {
      this.eventSelection.filter(t => t.checked).forEach(t => {
        t.checked = false;
      });
    }
  }


  clearChartSelection(): void{
    if(this.chartSelection.length > 0){
      this.chartSelection.filter(t => t.checked).forEach(t => {
        t.checked = false;
      });
    }
  }


  // Selecting an image favorite turns on the tab that shows it.
  onImageFavoriteChecked(checked: boolean): void {
    if (checked) {
      this.includeFavoritesTab = true;
    }
  }


  clearImageSelection(): void {
    this.imageSelection.filter(t => t.checked).forEach(t => {
      t.checked = false;
    });
  }


  // Selecting a map favorite turns on the tab that shows it.
  onMapFavoriteChecked(checked: boolean): void {
    if (checked) {
      this.includeFavoritesTab = true;
    }
  }


  clearMapSelection(): void {
    this.mapSelection.filter(t => t.checked).forEach(t => {
      t.checked = false;
    });
  }


  addOrUpdateDashboard(): void {
    if (this.dashboardName == null || this.dashboardName.trim() == '') {
      this.toastr.error('Please enter a valid dashboard name');
      return;
    }

    if (!this.dashboards.some(x=>x.name === this.dashboardName.trim()) || this.updateFlag) {
      this.setDashboardInfo();

      if(this.updateFlag){
        // Editing is independent of the loaded view, so don't flip the displayed
        // dashboard into its loading state while the update saves.
        this.updateDashboard();
      } else{
        this.dashboardFinishedTasks = false;
        this.createDashboard();
      }
      this.modalRef.hide();
    } else {
      this.toastr.error('Entered dashboard name already exists. Please enter a new one');
    }
  }


  setDashboardInfo(): void {
    this.makeDashboard.name = this.dashboardName.trim();
    this.makeDashboard.chartFavoriteIds = [];
    this.makeDashboard.imageFavoriteIds = [];
    this.makeDashboard.mapFavoriteIds = [];
    this.makeDashboard.eventIDs = [];
    this.makeDashboard.userName = this.username;
    this.makeDashboard.userGroupID = (this.selectedUserGroup != null && this.selectedUserGroup.id > -1) ? this.selectedUserGroup.id : null;
    this.makeDashboard.includeChartsTab = this.includeFavoritesTab ? 1 : 0;
    this.makeDashboard.includeEventsTab = this.includeEventsTab ? 1 : 0;
    this.makeDashboard.includeIsalTab = this.includeIsalTab ? 1 : 0;
    this.makeDashboard.includeImageFavoritesTab = this.includeFavoritesTab ? 1 : 0;
    this.makeDashboard.includeMapFavoritesTab = this.includeFavoritesTab ? 1 : 0;
    this.makeDashboard.computeActionSumCountsForEvents = this.computeActionSumCountsForEvents ? 1 : 0;

    this.eventSelection.forEach(e => {
      if (e.checked) {
        this.makeDashboard.eventIDs.push(e.id);
        e.checked = false;
      }
    });

    this.chartSelection.forEach(c => {
      if (c.checked) {
        this.makeDashboard.chartFavoriteIds.push(c.id);
        c.checked = false;
      }
    });

    this.imageSelection.forEach(c => {
      if (c.checked) {
        this.makeDashboard.imageFavoriteIds.push(c.id);
        c.checked = false;
      }
    });

    this.mapSelection.forEach(c => {
      if (c.checked) {
        this.makeDashboard.mapFavoriteIds.push(c.id);
        c.checked = false;
      }
    });
  }


  createDashboard(): void {
    this._dashboardEventsService.createDashboard(this.makeDashboard).subscribe(
      result => {
        if (result != null) {
          this.createMessageData(MessageActionType.New, this.makeDashboard, '');
          this.clearDashboardSelection();
          this.getDashboards(result);
          this.toastr.success('Dashboard created successfully.');
          this.dashboardFinishedTasks = true;
        }
        return;
      },
      err => {
        this.toastr.error('Error occurred while creating dashboard.');
      });
  }


  updateDashboard(): void {
    if (this.editingDashboard != undefined) {
      this.makeDashboard.id = this.editingDashboard.id;
      this._dashboardEventsService.updateDashboard(this.makeDashboard, this.username).subscribe(
        result => {
          if (result == 'success') {
            this.createMessageData( MessageActionType.Edited, this.makeDashboard, this.getEditChanges(this.makeDashboard));
            // Refresh the list in place; do not load or switch the displayed view.
            this.getDashboards(null, true);
            this.toastr.success('Dashboard updated successfully.');
          }
          return;
        },
        err => {
          this.toastr.error('Error occurred while creating dashboard.');
        });
    } else{
      this.dashboardEvents = [];
      this.clearTriggerSelection();
    }
  }


  deleteDashboard(dashboard: DashboardInfo): void {
    this.confirmationService.confirm({
      message: 'Do you want to delete this Dashboard?',
      header: 'Delete Confirmation',
      icon: 'glyphicon glyphicon-warning-sign',
      accept: () => {
        if (dashboard != undefined) {
          this.createMessageData(MessageActionType.Deleted, this.makeDashboard, '');
          this._dashboardEventsService.deleteDashboard(dashboard.id, this.username).subscribe(
            result => {
              if (result == 'success') {
                // Only clear the view if the dashboard being displayed was deleted.
                if (this.selectedDashboard != undefined && this.selectedDashboard.id === dashboard.id) {
                  this.clearTriggerSelection();
                  this.clearDashboardSelection();
                  localStorage.removeItem(DashboardComponent.LAST_SELECTED_STORAGE_KEY);
                }
                this.getDashboards(null, true);   // refresh list, keep current view
                this.toastr.success('Dashboard deleted successfully');
              }
              return;
            },
            err => {
              this.toastr.error('Error occurred while deleting dashboard.');
            });
        }
      },
      reject: () => {
      }
    });
  }


  setDashboardSelection(id: number): void {
    this.selectedDashboard = this.dashboards.filter(x => x.id == id)[0];
    this.dashboardSelectionChanged();
  }


  dashboardSelectionChanged(): void {
    this.clearChartSelection ();
    this.clearTriggerSelection();

    if (this.selectedDashboard != undefined) {
      this.dashboardFinishedTasks = false;
      this.selectedDashboardBuildStarted = false;
      this.selectedDashboard = this.dashboards.find(d => d.id == this.selectedDashboard.id);
      localStorage.setItem(DashboardComponent.LAST_SELECTED_STORAGE_KEY, String(this.selectedDashboard.id));
      this.getSelectedDashboardChartFavorites();
      this.getSelectedDashboardEventConditionValues();
      this.getSelectedDashboardEventLogs();
    }
    else {
      localStorage.removeItem(DashboardComponent.LAST_SELECTED_STORAGE_KEY);
      this.dashboardEvents = [];
      this.dashboardEvents = [...this.dashboardEvents];
      this.dashboardCharts = [];
      this.dashboardCharts = [...this.dashboardCharts];
    }
  }


  // Load the readings of each of the dashboard's chart favorites with the same
  // sensor-reading call the Analyze Sensor Readings page uses (one request per
  // favorite), so a favorite shows the same data on both pages (including archived
  // readings, in the favorite's saved time zone).
  getSelectedDashboardChartFavorites(): void {
    this.selectedDashboardChartDataLoaded = false;
    this.dashboardCharts = [];
    this.dashboardChartReadings = new Map<number, SensorReadingInfo[]>();

    // The favorites' sensors, reading types and date ranges come from the master list.
    if (this.chartFavorites.length === 0) {
      this.getChartFavorites(() => this.loadSelectedDashboardChartReadings(), false);
    } else {
      this.loadSelectedDashboardChartReadings();
    }
  }


  private loadSelectedDashboardChartReadings(): void {
    const favorites = this.selectedDashboard.chartFavoriteIds
      .map(id => this.chartFavorites.find(c => c.id == id))
      .filter(c => c != undefined);

    const requests = favorites.map(favorite => {
      const range = decodeDateRange(favorite.dateRange)?.range ?? presetDateRange('Last 7 Days');
      const details = this.buildSavedChartDetails(favorite);
      const [timeZone, timeZoneOffset] = this.common.setTimeZoneSelection(details.timeZone ?? 'Local');

      const criteria: SensorReadingCriteria2 = {
        sensorIds: favorite.sensors.map(s => s.id),
        startDate: range.startDate.format('YYYY-MM-DD HH:mm'),
        endDate: range.endDate.format('YYYY-MM-DD HH:mm'),
        timeZoneDisplay: timeZone,
        timeZoneOffset: timeZoneOffset,
        sensorReadingTypes: favorite.sensorReadingTypes
      };

      // A failing favorite yields no readings rather than blanking the whole dashboard.
      return this._sensorService.getSensorReadingsForSensor(criteria).pipe(
        map((results: SensorReadingInfo[]) => ({ id: favorite.id, readings: this.prepareChartReadings(results) })),
        catchError(() => of({ id: favorite.id, readings: [] as SensorReadingInfo[] })));
    });

    if (requests.length < 1) {
      this.selectedDashboardChartDataLoaded = true;
      this.checkReadyToBuildDashboard();
      return;
    }

    forkJoin(requests).subscribe(results => {
      results.forEach(r => this.dashboardChartReadings.set(r.id, r.readings));
      this.selectedDashboardChartDataLoaded = true;
      this.checkReadyToBuildDashboard();
    });
  }


  // Same clean-up as the Analyze page (review-readings.component): drop NaN values,
  // convert the dates and values, then order by date. The API does not sort, and the
  // chart draws its lines in array order, so unsorted readings show up as diagonal
  // lines across the chart.
  private prepareChartReadings(results: SensorReadingInfo[]): SensorReadingInfo[] {
    const readings = (results ?? []).filter(
      s => s.value != 'nan' && s.value != 'NaN' && s.origValue != 'nan' && s.origValue != 'NaN');
    readings.forEach(reading => {
      reading.createdDate = new Date(reading.createdDate);
      reading.value = Number(reading.value).toPrecision(9);
      reading.origValue = Number(reading.origValue).toPrecision(9);
    });
    return readings.sort((a, b) => a.createdDate.getTime() - b.createdDate.getTime());
  }


  getSelectedDashboardEventConditionValues(): void {
    this.selectedDashboardEventConditionValuesLoaded = false;
    const dashboardCriteria: DashboardEventLogCriteria = {
      eventIds: this.selectedDashboard.eventIds,
      eventLogCountPerEvent: 6   // past x hours
    };
    this._dashboardEventsService.getDashboardEventValues(dashboardCriteria).subscribe(
      results => {
        if (results != null) {
          this.dashboardConditionValues = results;
          this.sortDashboardEventValuesByCreatedDate(this.dashboardConditionValues);
        } else {
          this.toastr.warning('No recent event values found.');
        }
        this.selectedDashboardEventConditionValuesLoaded = true;
        this.checkReadyToBuildDashboard();
        return;
      },
      err => {
        this.toastr.error('Error occurred while retrieving recent event values.');
      });
  }


  checkReadyToBuildDashboard() {
    if (this.selectedDashboardChartDataLoaded == true && this.selectedDashboardEventConditionValuesLoaded == true &&
        this.selectedDashboardEventLogsLoaded == true && this.selectedDashboardBuildStarted == false) {
        this.selectedDashboardBuildStarted = true;
        this.dashboardFinishedTasks = true;
        this.buildDashboardInfo();
      }
  }


  buildDashboardInfo(): void {
    this.buildNewDashboardEventList(this.selectedDashboard.eventIds);
    this.mapEventLogInfos2DashboardEvents(this.selectedDashboardEventLogInfo);
    this.loadDashboardCharts();
    this.buildListOfChartFavoritesAssociatedWithDashboardEvents();
    this.buildListOfChartFavoritesNOTAssociatedWithDashboardEvents(this.selectedDashboard.eventIds);
    this.updateDashboardChartRangesWithAndWithoutEvents();
    this.checkEventWindowState();
  }


  buildListOfChartFavoritesAssociatedWithDashboardEvents() {
    this.dashboardEvents.forEach(x => {
      var dashboardCharts = this.dashboardCharts.filter(y => y.name.toLowerCase() == x.eventName.toLowerCase());

      if (dashboardCharts.length > 0) {
        x.chartData = dashboardCharts[0].chartData;
        x.isChartAvailable = true;

        // Carry the eChart inputs onto the event so its small card can render one.
        x.sensors = dashboardCharts[0].sensors;
        x.sensorReadingTypes = dashboardCharts[0].sensorReadingTypes;
        x.sensorReadings = dashboardCharts[0].sensorReadings;
        x.savedChartDetails = dashboardCharts[0].savedChartDetails;
        x.includeCalValues = dashboardCharts[0].includeCalValues;
        x.includeOrigValues = dashboardCharts[0].includeOrigValues;
        x.chartFavoriteID = dashboardCharts[0].chartFavoriteID;
        x.manualScaling = dashboardCharts[0].manualScaling;
        x.manualScaleYMin = dashboardCharts[0].manualScaleYMin;
        x.manualScaleYMax = dashboardCharts[0].manualScaleYMax;
      }
    });
  }


  buildListOfChartFavoritesNOTAssociatedWithDashboardEvents(eventIDs: number[]) {
    this.dashboardChartsWithoutEvents = [];

    this.dashboardCharts.forEach(x => {
      var dashboardEvents = this.dashboardEvents.filter(y => y.eventName.toLowerCase() == x.name.toLowerCase());

      if (dashboardEvents.length < 1) {
        this.dashboardChartsWithoutEvents.push(x);
      }
    });
  }

  
  getChartFavoritesAssociatedWithEvent(eventID: number): ChartFavoriteInfo[] {
    if (eventID == undefined || eventID < 0) return;

    const selectedEvent = this.events.find(e => e.id == eventID);
    if (selectedEvent == undefined) return;

    const sensorGroupIds: number[] = [];
    selectedEvent.sensorConditions.forEach(s => {
      sensorGroupIds.push(s.sensorGroup.id);
    });

    var chartFavoriteInfos: ChartFavoriteInfo[] = [];

    this.dashboardCharts.forEach(dChart => {
      const isIncluded = sensorGroupIds.includes(dChart.sensorGroupId);
      if (isIncluded) {
        var chartFav = this.chartFavorites.find(c => c.id == dChart.chartFavoriteID);
        if (chartFav != undefined) {
          chartFavoriteInfos.push(chartFav);
        }

      }
    });

    return chartFavoriteInfos;
  }


  updateDashboardChartRangesWithAndWithoutEvents() {
    this.dashboardEvents.forEach(x => {
      var chartFavorites = this.chartFavorites.filter(y => y.id == x.chartId); //this.getChartFavoritesAssociatedWithEvent(x.eventId);
      if (chartFavorites.length > 0) {
        x.chartScaleYMin = chartFavorites[0].scaleYMin;
        x.chartScaleYMax = chartFavorites[0].scaleYMax;
        x.chartAutoScale = (x.chartScaleYMin != undefined && x.chartScaleYMin.toString() != '' &&
                            x.chartScaleYMax != undefined && x.chartScaleYMax.toString() != '') ? false : true;
      }
    });

    this.dashboardChartsWithoutEvents.forEach(x => {
      var chartFavorites = this.chartFavorites.filter(y => y.id == x.chartFavoriteID);
      if (chartFavorites.length > 0) {
        x.chartScaleYMin = chartFavorites[0].scaleYMin;
        x.chartScaleYMax = chartFavorites[0].scaleYMax;
        x.chartAutoScale = (x.chartScaleYMin != undefined && x.chartScaleYMin.toString() != '' &&
                            x.chartScaleYMax != undefined && x.chartScaleYMax.toString() != '') ? false : true;
      }
    });
  }


  buildNewDashboardEventList(eventIDs: number[]) {
    this.dashboardEvents = [];
    if (eventIDs == null) {
      return;
    }

    const selectedEvents = this.events.filter(e => eventIDs.includes(e.id)); // && e.isDisabled == false);
    if (selectedEvents != null) {
      selectedEvents.forEach(e => {
        const dashboardEvent: DashboardEvent = {
          eventId: e.id,
          eventName: e.name,
          eventType: e.eventType,
          eventConditions: this.buildDashboardEventConditions(e),
          eventDisabled: e.isDisabled,
          lastTriggeredDate: null,
          lastTriggeredActionResults: [],
          eventLogHistory: [],
          elapsedTime: null,
          isChartAvailable: false,
          chartId: 0,
          chartData: null,
          eventActiveState: 'unknown',
          chartAutoScale: true,
          chartScaleYMax: null,
          chartScaleYMin: null
        };

        this.dashboardEvents.push(dashboardEvent);
      });

      this.sortDashboardEventsByEventName(this.dashboardEvents);
    }
  }


  sortDashboardEventsByEventName(dashboardEvents: DashboardEvent[]) {
    dashboardEvents.sort((a, b) => {

      if (b.eventName > a.eventName) {
        return -1;
      }
      if (b.eventName < a.eventName) {
        return 1;
      }
    });
  }


  buildDashboardEventConditions(event: Event): DashboardEventCondition[] {
    const dashboardEventConditions: DashboardEventCondition[] = [];

    if (event.eventType == EventType.SensorBased && event.sensorConditions != null) {
      for (let index=0; index < event.sensorConditions.length; index++) {
        const s = event.sensorConditions[index];
        const dashboardCondition: DashboardEventCondition = {
          sensorGroupName: this.getSensorGroupNameForID(s.sensorGroup.id),
          timerName: '',
          condition: this.buildDisplayConditionText(event, index),
          value: this.common.setValuePrecisionForKey(Number(this.getConditionValue(s.eventID, s.id)), this.getSensorDataTypeNameForID(s.sensorReadingType.id)).toString(),
          //value: this.getConditionValue(s.eventID, s.id),
          errorCode: this.getConditionErrorCode(s.eventID, s.id),
          plantAge: this.getPlantAgeFromSensorGroup(s.sensorGroup.id),
          id: s.id
        };
        dashboardEventConditions.push(dashboardCondition);
      }
    }
    else if (event.eventType == EventType.TimerBased && event.sensorConditions != null) {
      for (let index=0; index < event.timerConditions.length; index++) {
        const t = event.timerConditions[index];
        const dashboardCondition: DashboardEventCondition = {
          sensorGroupName: '',
          timerName: (t.type == TimerEventType.Single ? 'Timer Single' : 'Timer Repeat'),
          condition: this.buildDisplayConditionText(event, index),
          value: '',
          errorCode: -1,
          plantAge: '',
          id: t.id
        };
        dashboardEventConditions.push(dashboardCondition);
      }
    }

    return dashboardEventConditions;
  }


  getConditionValue(eventID: number, conditionID: number): string {
    const eventC = this.dashboardConditionValues.find(i => i.eventId == eventID);

    if (eventC != null) {
      const conditionValue = eventC.eventConditionValues.find(c => c.conditionId == conditionID);
      if (conditionValue != null) {
        return conditionValue.value;
      }
    }
    return '';
  }


  getConditionErrorCode(eventID: number, conditionID: number): number {
    const eventC = this.dashboardConditionValues.find(i => i.eventId == eventID);

    if (eventC != null) {
      const conditionValue = eventC.eventConditionValues.find(c => c.conditionId == conditionID);
      if (conditionValue != null) {
        return (conditionValue.errorCode == 0) ? -1 : conditionValue.errorCode;
      }
    }
    return -1;
  }


  buildDisplayConditionText(event: Event, conditionIndex: number): string {
    if (event.eventType == EventType.SensorBased) {
      const s = event.sensorConditions[conditionIndex];
      const condition = this.getSensorDataTypeNameForID(s.sensorReadingType.id) + ' ' + s.comparator + ' ' + s.threshold;
      return  conditionIndex == event.sensorConditions.length - 1 ? condition : condition + ' ' + s.logicOperator.toLowerCase();
    }

    if (event.eventType == EventType.TimerBased) {
      const t = event.timerConditions[conditionIndex];
      if (t.type == TimerEventType.Single) {
        const condition = 'Single @ ' + t.timingSingle + ' on (' + this.buildDaysOfWeekBoolUserView(t.daysOfWeek) + ')';
        return  conditionIndex == event.timerConditions.length - 1 ? condition : condition  + ' ' + t.logicOperator.toLowerCase();
      } else {
        const condition = 'Repeat @ ' + event.evaluateStartTime + ', ' + t.timingRepeat + ' on (' + this.buildDaysOfWeekBoolUserView(t.daysOfWeek) + ')';
        return  conditionIndex == event.timerConditions.length - 1 ? condition : condition  + ' ' + t.logicOperator.toLowerCase();
      }
    }
  }


  getPlantAgeFromSensorGroup(sensorGroupID: number): string {
    const sensorGroup = this.sensorGroups.find(s => s.id == sensorGroupID);
    if (sensorGroup != null) {
      if (sensorGroup.plantDate != null) {
        return (-1 * moment.utc(sensorGroup.plantDate).local().diff(moment(),'days')).toString();
      }
    }
    return '-';
  }


  getSelectedDashboardEventLogs(): void {
    this.selectedDashboardEventLogsLoaded = false;
    var forkJoinServices: any[] = [];

    var groupSize = 4;
    var groupCount = Math.ceil(this.selectedDashboard.eventIds.length / groupSize);

    for (var count = 0; count < groupCount; count++) {
        var endRange = (count + 1) * groupSize;
        if (endRange > this.selectedDashboard.eventIds.length) {
          endRange = this.selectedDashboard.eventIds.length;
        }
        var subSetIds = slice(this.selectedDashboard.eventIds, count * groupSize, endRange);  

        const dashboardCriteria: DashboardEventLogCriteria = {
          eventIds: subSetIds,
          eventLogCountPerEvent: 5    // 7
        };

        forkJoinServices.push( this._dashboardEventsService.getDashboardEventLogs(dashboardCriteria) );
    }

    if (forkJoinServices.length < 1) {
      this.selectedDashboardEventLogsLoaded = true;
      return;
    }

    forkJoin(forkJoinServices).subscribe(
      results => {
        this.selectedDashboardEventLogInfo = [];
        results.forEach(eventLogs => {
          eventLogs.forEach(x => this.selectedDashboardEventLogInfo.push(x));
        });

        this.selectedDashboardEventLogsLoaded = true;
        this.checkReadyToBuildDashboard();
      });
  }


  sortEventLogsByCreatedDate(eventLogInfos: EventLogInfo[]) {
    eventLogInfos.sort((a, b) => {
      if (b.createdDate < a.createdDate) {
        return -1;
      }
      if (b.createdDate > a.createdDate) {
        return 1;
      }
    });
  }


  sortDashboardEventValuesByCreatedDate(eventValues: DashboardEventValue[]) {
    eventValues.sort((a, b) => {
      if (b.createdDate < a.createdDate) {
        return -1;
      }
      if (b.createdDate > a.createdDate) {
        return 1;
      }
    });
  }


  mapEventLogInfos2DashboardEvents(eventLogInfos: EventLogInfo[]) {
    eventLogInfos.forEach(e => {
      const dashboardEvent = this.dashboardEvents.find(d => d.eventId == e.eventID);

      if (dashboardEvent != null) {
        const eventLogHistory: DashboardEventLogHistory = {
          id: e.id,
          eventLogInfoID: e.id,
          lastTriggeredDate: e.createdDate,
          createdDate: moment.utc(e.createdDate).local().toDate(),
          conditionResults: this.buildCombinedConditionResults(e),
          actionResults: this.buildCombinedActionResults(e),
          elapsedTime: 0,
          overallConditionResult: ''
        };
        dashboardEvent.eventLogHistory.push(eventLogHistory);
      }
    });
    this.updateDashboardEventDateTime();
  }


  buildCombinedConditionResults(eventLogInfo: EventLogInfo): EventLogResult[] {
    const results: EventLogResult[] = [];
    const eventType = Object.values(EventType)[eventLogInfo.eventType];

    if (eventType == EventType.SensorBased && eventLogInfo.sensorEventResultInfos != null) {
      let tempResult = '';
      this.eventMapper.sortSensorEventResultInfosByOrder(eventLogInfo.sensorEventResultInfos);
      for (let index = 0; index < eventLogInfo.sensorEventResultInfos.length; index++) {
        const e = eventLogInfo.sensorEventResultInfos[index];
        var sensorReadingType = this.getNameForSensorReadingTypeID(e.sensorReadingTypeID);
        tempResult = this.getNameForSensorGroupID(e.sensorGroupID) + ' | ' + sensorReadingType + ' ' +
                      this.eventMapper.getComparatorAtIndex(e.comparator) + ' ' + e.threshold;
        if (index != eventLogInfo.sensorEventResultInfos.length - 1) {
          tempResult = tempResult + '  ' + Object.values(LogicOperator)[e.logicOperator].toLowerCase();
        }
        const eventLogResult: EventLogResult = {
          value: this.common.setValuePrecisionForKey(e.calculatedValue, sensorReadingType).toString(),
          //value: e.calculatedValue.toString(),
          text: tempResult,
          parentID: e.id,
          parentType: EventType.SensorBased
        };
        results.push(eventLogResult);
      }
      return results;
    }
    else if (eventType == EventType.TimerBased && eventLogInfo.timerEventResultInfos != null) {
      let tempResult = '';
      this.eventMapper.sortTimerEventResultInfosByOrder(eventLogInfo.timerEventResultInfos);
      for (let index = 0; index < eventLogInfo.timerEventResultInfos.length; index++) {
        const t = eventLogInfo.timerEventResultInfos[index];
        if (t.type == 0) {
          const newTime = moment.utc(t.timingSingle).local().format('HH:mm');
          const newDaysOfWeek = this.eventMapper.convertUTCDaysOfWeek2LocalString(t.timingSingle, newTime, t.daysOfWeek);
          tempResult = Object.values(TimerEventType)[t.type] + ' @ ' +  newTime  + ' (' + this.buildDaysOfWeekStringUserView(newDaysOfWeek) + ')';
        } else if (t.type == 1) {
          tempResult = Object.values(TimerEventType)[t.type] + ' ' + Object.values(TimingInterval)[t.timingRepeat] + ' (' + this.buildDaysOfWeekStringUserView(t.daysOfWeek) + ')';
        }

        if (index != eventLogInfo.timerEventResultInfos.length - 1) {
          tempResult = tempResult + '  ' + Object.values(LogicOperator)[t.logicOperator].toLowerCase();
        }
        const eventLogResult: EventLogResult = {
          value: (t.result ? 'true' : 'false'),
          text: tempResult,
          parentID: t.id,
          parentType: EventType.TimerBased
        };
        results.push(eventLogResult);
      }
      return results;
    } else {
      const eventLogResult: EventLogResult = {
        value: '0',
        text: 'not evaluated',
        parentID: -1,
        parentType: null
      };
      results.push(eventLogResult);
      return results;
    }
  }


  buildCombinedActionResults(eventLogInfo: EventLogInfo): EventLogResult[] {
    if (eventLogInfo == null) {
      return;
    }

    const results: EventLogResult[] = [];
    if (eventLogInfo.actionResultInfos == null || eventLogInfo.actionResultInfos.length == 0) {

      let errorCode = -1;
      if ( eventLogInfo.eventType == 0 && eventLogInfo.sensorEventResultInfos != null) {
        const sensorEventWithCode = eventLogInfo.sensorEventResultInfos.find(s => s.errorCode != 0);
        if (sensorEventWithCode != null) {
          errorCode = sensorEventWithCode.errorCode;
        }
      }

      const eventLogResult: EventLogResult = {
        value: errorCode.toString(),
        text: this.getConditionErrorCodeText(errorCode),
        parentID: -1,
        parentType: null
      };
      results.push(eventLogResult);
      return results;
    }

    eventLogInfo.actionResultInfos.forEach(a => {
      const eventLogResult: EventLogResult = {
        value: a.result,
        text: Object.values(ActionType)[a.type] + ' - ' + this.common.getEventResultsText(parseInt(a.result)),
        parentID: -1,
        parentType: null
      };
      results.push(eventLogResult);
    });
    return results;
  }


  buildDaysOfWeekStringUserView(daysOfWeek: string): string {
    let result = '';

    result += daysOfWeek[0] == '1' ? 'Su ' : '';
    result += daysOfWeek[1] == '1' ? 'M ' : '';
    result += daysOfWeek[2] == '1' ? 'Tu ' : '';
    result += daysOfWeek[3] == '1' ? 'W ' : '';
    result += daysOfWeek[4] == '1' ? 'Th ' : '';
    result += daysOfWeek[5] == '1' ? 'F ' : '';
    result += daysOfWeek[6] == '1' ? 'Sa ' : '';

    return result.trim();
  }


  getNameForSensorGroupID(id: number): string {
    const obj = this.sensorGroups.find(x => x.id == id);
    return obj != null ? obj.name : '';
  }


  getNameForSensorReadingTypeID(id: number): string {
    const obj = this.sensorDataTypes.find(x => x.id == id);
    return obj != null ? obj.type : '';
  }


  public updateDashboardEventDateTime() {
    this.dashboardEvents.forEach(d => {
      if (d.eventLogHistory.length > 0) {
        d.lastTriggeredDate = this.convertUTCDateToLocal(d.eventLogHistory[0].lastTriggeredDate);
        d.elapsedTime = this.getElapsedTimeFromNow(d.lastTriggeredDate);
        if (d.eventLogHistory.length > 0) {
          d.lastTriggeredActionResults = [];
          d.eventLogHistory[0].actionResults.forEach(a => d.lastTriggeredActionResults.push(parseInt(a.value)));
        }
      }

      let historyIndex = 0;
      const lastSuccessActionIndex = -1;

      d.eventLogHistory.forEach(eventLog => {
        eventLog.lastTriggeredDate = this.convertUTCDateToLocal(eventLog.lastTriggeredDate);
        eventLog.elapsedTime = this.getElapsedTimeFromNow(eventLog.lastTriggeredDate);
        historyIndex++;
      });
    });
  }


  loadDashboardCharts(): void {
    this.dashboardCharts=[];
    this.selectedDashboard.chartFavoriteIds.forEach(chartFavoriteId => {
      const chartFavorite: ChartFavoriteInfo  = this.chartFavorites.filter(x => x.id == chartFavoriteId)[0];

      // Skip favorites whose master metadata isn't loaded yet rather than throwing
      // (which would abort the whole tile build).
      if (chartFavorite == undefined) {
        return;
      }

      const savedChartDetails = this.buildSavedChartDetails(chartFavorite);

      // The scalar sensorGroup is null for a favorite saved with only individual
      // sensors; fall back to the first multi-select group, otherwise derive a label
      // from the sensor names (id -1 never matches an event group).
      const primaryGroup = chartFavorite.sensorGroup ?? chartFavorite.sensorGroups?.[0];

      const dashboardChart: DashboardChartFavoriteCharts = {
        name: chartFavorite.name,
        chartData: [],   // legacy ngx-charts data; the eChart builds its own series
        sensorGroupName: primaryGroup?.name ?? chartFavorite.sensors.map(s => s.name).join(', '),
        sensorGroupId: primaryGroup?.id ?? -1,
        chartFavoriteID: chartFavorite.id,

        // Inputs for the reusable eChart component (it builds its own series).
        sensors: chartFavorite.sensors,
        sensorReadingTypes: chartFavorite.sensorReadingTypes,
        sensorReadings: this.dashboardChartReadings.get(chartFavorite.id) ?? [],
        savedChartDetails: savedChartDetails,
        // The favorite's saved display options; older favorites show calibrated only.
        includeCalValues: savedChartDetails.showCalibratedReadings ?? true,
        includeOrigValues: savedChartDetails.showOriginalReadings ?? false,
        manualScaling: chartFavorite.isManualScaling,
        manualScaleYMin: chartFavorite.scaleYMin,
        manualScaleYMax: chartFavorite.scaleYMax
      };

      this.dashboardCharts.push(dashboardChart);
      this.dashboardCharts = [...this.dashboardCharts];
    });

    this.dashboardCharts = this.dashboardCharts.sort((a, b) => a.name.toString().localeCompare(b.name.toString(), 'en', { numeric: true }));
  }


  // Parse a favorite's saved ChartDetails JSON for the eChart's [savedChartDetails]
  // input. Legacy favorites (no/blank/unparseable chartDetails) fall back to a
  // line chart driven by the favorite's outlier columns — mirrors the fallback in
  // review-readings.applyChartDetails().
  private buildSavedChartDetails(chartFavorite: ChartFavoriteInfo): ChartDetails {
    const raw = chartFavorite.chartDetails;
    if (raw != undefined && raw !== '') {
      try {
        const parsed = JSON.parse(raw);
        if (parsed != undefined) {
          return parsed;
        }
      } catch {
        // fall through to the legacy fallback
      }
    }

    return {
      echartType: 'line',
      yMinIgnore: (chartFavorite.outlierYMin == undefined) ? '' : chartFavorite.outlierYMin.toString(),
      yMaxIgnore: (chartFavorite.outlierYMax == undefined) ? '' : chartFavorite.outlierYMax.toString()
    };
  }


  sortDashboardChartsByName(charts: DashboardChartFavoriteCharts[]) {
    charts.sort((a, b) => {

      if (b.name > a.name) {
        return -1;
      }
      if (b.name < a.name) {
        return 1;
      }
    });
  }


  onDashboardCancelButton(): void {
    this.modalRef.hide();
  }


  showEventLogHistory(template: TemplateRef<any>, eventId: number): void{
    const selectedEvent = this.dashboardEvents.find(e => e.eventId == eventId);
    this.selectedEventLogHistory = selectedEvent.eventLogHistory;
    this.currentEventName = selectedEvent.eventName;
    this.modalRef = this.modalService.show(template, this.config);
  }


  // Tiles pass themselves (not an index) since the Favorites tab can be reordered.
  showDashboardChart(template: TemplateRef<any>, dashboardEvent: DashboardEvent) {
    this.currentEventName = dashboardEvent.eventName;
    this.setCurrentChartFromEChartSource(dashboardEvent);

    this.modalRef = this.modalService.show(template, { ...this.config, class: 'resizable-favorite-dialog' });
  }


  showDashboardChartWithNoEvent(template: TemplateRef<any>, chart: DashboardChartFavoriteCharts) {
    this.currentEventName = chart.name.toString();
    this.setCurrentChartFromEChartSource(chart);

    this.modalRef = this.modalService.show(template, { ...this.config, class: 'resizable-favorite-dialog' });
  }


  // Populate the popup modal's eChart inputs from the clicked chart source (a
  // DashboardEvent or a DashboardChartFavoriteCharts — both carry the eChart
  // fields).
  private setCurrentChartFromEChartSource(source: DashboardEvent | DashboardChartFavoriteCharts) {
    this.currentSensors = source.sensors ?? [];
    this.currentSensorReadingTypes = source.sensorReadingTypes ?? [];
    this.currentSensorReadings = source.sensorReadings ?? [];
    this.currentSavedChartDetails = source.savedChartDetails ?? null;
    this.currentIncludeCalValues = source.includeCalValues ?? true;
    this.currentIncludeOrigValues = source.includeOrigValues ?? false;
    this.currentChartFavoriteId = source.chartFavoriteID ?? 0;
    this.currentManualScaling = source.manualScaling ?? false;
    this.currentScaleYMin = source.manualScaleYMin ?? null;
    this.currentScaleYMax = source.manualScaleYMax ?? null;
  }


  showRecentConditionValues(dashboardEvent: DashboardEvent, eventCondition: DashboardEventCondition, template: TemplateRef<any>) {
    if (this.dashboardConditionValues == null) {
      return;
    }

    this.currentEventName = dashboardEvent.eventName;
    this.recentConditionValues = [];

    const currentEventConditionValues = this.dashboardConditionValues.filter(d => d.eventId == dashboardEvent.eventId);
    this.dashboardConditionValues.forEach(d => {
      d.eventConditionValues.forEach(v => {
        if (d.eventId == dashboardEvent.eventId && v.conditionId == eventCondition.id) {
          const newEventConditionValue: EventConditionValue = {
            conditionId: v.conditionId,
            createdDate: this.convertUTCDateToLocal(d.createdDate),
            value: this.common.setValuePrecisionForKey(Number(v.value), eventCondition.condition.split(' ')[0]).toString(),
            //value: v.value,
            errorCode: (v.errorCode == 0) ? -1 : v.errorCode,
            errorName: this.getConditionErrorCodeText((v.errorCode == 0) ? -1 : v.errorCode)
          };
          this.recentConditionValues.push(newEventConditionValue);
        }
      });
    });

    this.modalRef = this.modalService.show(template, { animated: false, backdrop: false, ignoreBackdropClick: false });
  }


  public getConditionErrorCodeText(errorCode: number): string {
    if (errorCode == -1) {
      return '';
    } else if (errorCode == 4) {
      return 'Not enough data';
    } else if (errorCode == 5) {
      return 'No recent data';
    } else if (errorCode == 6) {
      return 'Timed out';
    } else if (errorCode == 16) {
      return 'Manual-Timed out';
    } else {
      return 'Unknown ' + errorCode;
    }
  }


  // public getEventResultsText(eventAction: number): string {
  //   if (eventAction == -1) {
  //     return 'no action';
  //   } else if (eventAction == 0) {
  //     return 'Waiting';
  //   } else if (eventAction == 1) {
  //     return 'Triggered-Success';
  //   } else if (eventAction == 2) {
  //     return 'Triggered-Ignored';
  //   } else if (eventAction == 3) {
  //     return 'Triggered-Error';
  //   } else if (eventAction == 4) {
  //     return 'Not enough data';
  //   } else if (eventAction == 5) {
  //     return 'No recent data';
  //   } else if (eventAction == 6) {
  //     return 'Timed out';
  //   } else if (eventAction == 11) {
  //     return 'Manual-Success';
  //   } else if (eventAction == 12) {
  //     return 'Manual-Ignored';
  //   } else if (eventAction == 13) {
  //     return 'Manual-Error';
  //   } else if (eventAction == 16) {
  //     return 'Manual-Timed out';
  //   } else {
  //     return 'Unknown result ' + eventAction;
  //   }
  // }


  public getEventLogColor(eventAction: number): string {
    if (eventAction == 0) {
      return '#e3e3e3';   // Light gray
    } else if (eventAction == 1) {
      return '#a9d18e';  //'#00C851';  // Green
    } else if (eventAction == 2 || eventAction == 12) {
      return '#f6f728';  //'#f3f428';  // Yellow
    } else if (eventAction == 3 || eventAction == 13) {
      return '#e84848';  //'#FF0000';  // Red
    } else if (eventAction == 4) {
      return '#ff8130';  //'#F7680C';  // Dark orange
    } else if (eventAction == 5) {
      return '#ff9957';  //'#F78E12';  // Light orange
    } else if (eventAction == 6 || eventAction == 16) {
      return '#e84848';  //'#F78E12';  // Red
    } else if (eventAction == 11) {
      return '#b4c7e7';  //'#ADD8E6';  // Light blue
    } else {
      return 'clear';
    }
  }


  getEventLogResultColor(result: string): string {
    if (result == 'true') {
      return '#548235';  // Green
    } else {
      return 'black';
    }
  }

  startTimer() {
    this.getCurrentCountDown();
    setInterval(() => {
      this.getCurrentCountDown();
    },30000);
  }


  getCurrentCountDown() {
    const today= new Date();
    const currentMinute = today.getMinutes();
    if ((currentMinute >= 15 && currentMinute < 20) ||
        (currentMinute >= 45 && currentMinute < 50)) {
      this.timeToEvaluteDisplay = 'Evaluating now';
    } else if (currentMinute >= 20 && currentMinute < 45) {
      this.timeToEvaluteDisplay = '~' + (45 - currentMinute).toString() + ' min';
    } else if (currentMinute >= 50 && currentMinute <= 59) {
      this.timeToEvaluteDisplay = '~' + (15 + 60 - currentMinute).toString() + ' min';
    } else {
      this.timeToEvaluteDisplay = '~' + (15 - currentMinute).toString() + ' min';
    }
  }


  buildDaysOfWeekBoolUserView(daysOfWeek: boolean[]): string {
    let result = '';

    result += daysOfWeek[0] ? 'Su ' : '';
    result += daysOfWeek[1] ? 'M ' : '';
    result += daysOfWeek[2] ? 'Tu ' : '';
    result += daysOfWeek[3] ? 'W ' : '';
    result += daysOfWeek[4] ? 'Th ' : '';
    result += daysOfWeek[5] ? 'F ' : '';
    result += daysOfWeek[6] ? 'Sa ' : '';

    return result.trim();
  }


  getSensorDataTypeNameForID(id: number): string {
    const type = this.sensorDataTypes.find(s => s.id == id).type;
    return type != null ? type : 'unknown';
  }


  getSensorGroupNameForID(id: number): string {
    const sensorGroup = this.sensorGroups.find(s => s.id == id);
    return sensorGroup != null ? sensorGroup.name : 'unknown';
  }


  startTimerEventWindowCheck() {
    this.checkEventWindowState();
    setInterval(() => {
      this.checkEventWindowState();
    },30000);
  }


  checkEventWindowState() {
    if (this.events == null) {
      return;
    }

    this.dashboardEvents.forEach(d => {
      const event = this.events.find(e => e.id == d.eventId);

      if (event != null) {
        d.eventActiveState = event.isDisabled ? '' : this.checkEventTimeWindow(event);
      } else {
        d.eventActiveState = 'unknown';
      }
    });
  }


  public checkEventTimeWindow(event: Event): string {
    const m = moment();
    const currentMinute = (m.hour()*60) + m.minute();
    const dayOfWeek = moment().weekday();
    const startMinutes = (moment(event.evaluateStartTime, 'HH:mm').hour()*60) + moment(event.evaluateStartTime, 'HH:mm').minute();
    const endMinutes = (moment(event.evaluateEndTime, 'HH:mm').hour()*60) + moment(event.evaluateEndTime, 'HH:mm').minute();

    if (event.evaluateDaysOfWeek[dayOfWeek] == true) {      // Window starts on current day
      if (startMinutes < endMinutes) {                      // entire window during the day
        if (currentMinute >= startMinutes && currentMinute <= endMinutes ) {
          return 'active';
        }
      } else if (startMinutes > endMinutes) {                 // Window includes midnight
        if (currentMinute >= startMinutes) {                // This covers part before midnight
          return 'active';
        }
      }
    }
    // Window started day before
    if (event.evaluateDaysOfWeek[(dayOfWeek-1 < 0) ? 6 : dayOfWeek-1] == true) {
      if (startMinutes > endMinutes && currentMinute <= endMinutes) {
        return 'active';
      }
    }

    return 'inactive';
  }


  public getEventWindowActiveColor(state: string): string {
    if (state == 'active') {
      return '#a9d18e';  // green
    } else if (state == 'inactive') {
      return '#f6f728';  // yellow
    } else {
      return 'clear';
    }
  }


  // itemName/userNotes default to the edit modal's values; the Favorites-tab
  // reorder (no modal) passes the displayed dashboard's name and no notes.
  createMessageData(msgActionType: MessageActionType, dashboard: DashboardRequest, msgNote: string,
                    itemName: string = this.dashboardName, userNotes: string = this.changeLogNotes) {
    const message: Message = {
      id: 0,
      messageType: MessageType.Audit,
      appComponentName: AppComponentName.Dashboard,
      appComponentItem: itemName,
      actionType: msgActionType,
      details: msgNote,
      userNotes: userNotes,
      count: 1,
      acknowledged: false,
      userName: this.username,
      userGroupId: dashboard.userGroupID
    };

    this._appMessageService.createAppMessage(message).subscribe(
      results => {
        if (results != null) {
          //this.toastr.success('Success');
        } else {
          //this.toastr.warning('Not found.');
        }
        return;
      },
      err => {
        //this.toastr.error('Error occurred while saving change log.');
      });
  }


  getEditChanges(dashboard: DashboardRequest): string {
    let results = '';
    const original: DashboardInfo = JSON.parse(this.preEditObjectAsJSONString);

    results += this.common.compareProperty('Name', original.name, dashboard.name);
    results += this.common.compareProperty('userName', original.userName, dashboard.userName);
    results += this.common.compareProperty('userGroupID', this.common.prepareProperty4String(original.userGroupId), this.common.prepareProperty4String(dashboard.userGroupID));
    results += this.common.compareProperty('EventsCount', original.eventIds.length.toString(), dashboard.eventIDs.length.toString());
    results += this.common.compareProperty('ChartsCount', original.chartFavoriteIds.length.toString(), dashboard.chartFavoriteIds.length.toString());
    results += this.common.compareProperty('ImageFavoritesCount', (original.imageFavoriteIds ?? []).length.toString(), dashboard.imageFavoriteIds.length.toString());
    results += this.common.compareProperty('MapFavoritesCount', (original.mapFavoriteIds ?? []).length.toString(), dashboard.mapFavoriteIds.length.toString());
    results += this.common.compareProperty('IncludeEventsTab', original.includeEventsTab.toString(), dashboard.includeEventsTab.toString());
    results += this.common.compareProperty('IncludeChartsTab', original.includeChartsTab.toString(), dashboard.includeChartsTab.toString());
    results += this.common.compareProperty('IncludeIsalTab', original.includeIsalTab.toString(), dashboard.includeIsalTab.toString());
    results += this.common.compareProperty('IncludeImageFavoritesTab', (original.includeImageFavoritesTab ?? 0).toString(), dashboard.includeImageFavoritesTab.toString());
    results += this.common.compareProperty('IncludeMapFavoritesTab', (original.includeMapFavoritesTab ?? 0).toString(), dashboard.includeMapFavoritesTab.toString());
    results += this.common.compareProperty('ComputeActionSumCountsForEvents', original.computeActionSumCountsForEvents.toString(), dashboard.computeActionSumCountsForEvents.toString());

    return results;
  }


  addNotes2ChangeLog() {
    this.changeLogNotes = '';
    
    const params: ChangeLogNotesParams = {
      changeLogNotes: this.changeLogNotes,
      userGroupId: 0,
      category: ''
    };

    var modalRef = this.modalService.show(ChangeLogNotesComponent, { animated: false, backdrop: false, ignoreBackdropClick: true, class: 'modal-above-confirmdialog', initialState: params });
    modalRef.content.onChangeLogNotes.subscribe((value) => {
      this.changeLogNotes = value;
    });
  }

  
  private convertUTCDateToLocal(date: Date): Date {
    return new Date(moment.utc(date).local().toDate());
  }


  private getElapsedTimeFromNow(date: Date): number {
    const currentTime: Date = new Date();
    return parseFloat(((currentTime.getTime() - date.getTime()) / (3600 * 1000)).toPrecision(3));
  }


  showDataPointsOnChart(chart) {
    this.charting.showDataPointsOnChart(chart);
  }


  // A search of "*" lists the first ASTERISK_SEARCH_LIMIT entries (checked ones first)
  // instead of filtering by name, and says so. Shared by the four tabs of the edit dialog.
  private static readonly ASTERISK_SEARCH_LIMIT = 300;

  private isAsteriskSearch(search: string): boolean {
    return (search ?? '').trim() === '*';
  }

  private firstEntriesForAsteriskSearch<T extends { checked: boolean }>(items: T[]): T[] {
    this.toastr.info(`First ${DashboardComponent.ASTERISK_SEARCH_LIMIT} returned`);
    return [...items]
      .sort((x, y) => (x.checked == y.checked) ? 0 : x.checked ? -1 : 1)
      .slice(0, DashboardComponent.ASTERISK_SEARCH_LIMIT);
  }


  searchEventsTextChanged() {
    if (this.isAsteriskSearch(this.eventsSearch)) {
      this.eventsDisplayed = this.firstEntriesForAsteriskSearch(this.eventSelection);
      this.eventsSearchNote = `Searched ${this.eventsDisplayed.length} of ${this.eventSelection.length}`;
      return;
    }

    var searchResults: DashboardEventSelection[] = [];
    const searchLimit = 500;
    let checkedCount = 0;

    if (this.eventsSearch == undefined || this.eventsSearch == '' || this.eventsSearch == 'null') {
      searchResults = this.eventSelection.filter(s => s.checked == true);
    }
    else {
      this.eventsSearch = this.eventsSearch.toLowerCase();
      searchResults = this.eventSelection.filter(s => (s.name != undefined ? s.name.toLowerCase().includes(this.eventsSearch) : false) || s.checked == true);
    }

    const displayCount = (searchResults.length > checkedCount + searchLimit) ? checkedCount + searchLimit : searchResults.length;

    searchResults = searchResults.sort((x, y) => (x.checked == y.checked) ? 0 : x.checked ? -1 : 1);
    this.eventsDisplayed = searchResults.slice(0, displayCount);

    if (this.eventsDisplayed.length < searchLimit) {
      this.eventsSearchNote = `Searched ${this.eventsDisplayed.length} of ${this.eventSelection.length}`;
    }
    else {
      this.eventsSearchNote = `Searched ${this.eventsDisplayed.length} of ${this.eventSelection.length} (limit)`;
    }
  }


  searchImagesTextChanged() {
    if (this.isAsteriskSearch(this.imagesSearch)) {
      this.imagesDisplayed = this.firstEntriesForAsteriskSearch(this.imageSelection);
      this.imagesSearchNote = `Searched ${this.imagesDisplayed.length} of ${this.imageSelection.length}`;
      return;
    }

    var searchResults: DashboardChart[] = [];

    if (this.imagesSearch == undefined || this.imagesSearch == '' || this.imagesSearch == 'null') {
      searchResults = this.imageSelection.filter(s => s.checked == true);
    }
    else {
      this.imagesSearch = this.imagesSearch.toLowerCase();
      searchResults = this.imageSelection.filter(s => (s.name != undefined ? s.name.toLowerCase().includes(this.imagesSearch) : false) || s.checked == true);
    }

    this.imagesDisplayed = searchResults.sort((x, y) => (x.checked == y.checked) ? 0 : x.checked ? -1 : 1);
    this.imagesSearchNote = `Searched ${this.imagesDisplayed.length} of ${this.imageSelection.length}`;
  }


  searchMapsTextChanged() {
    if (this.isAsteriskSearch(this.mapsSearch)) {
      this.mapsDisplayed = this.firstEntriesForAsteriskSearch(this.mapSelection);
      this.mapsSearchNote = `Searched ${this.mapsDisplayed.length} of ${this.mapSelection.length}`;
      return;
    }

    var searchResults: DashboardChart[] = [];

    if (this.mapsSearch == undefined || this.mapsSearch == '' || this.mapsSearch == 'null') {
      searchResults = this.mapSelection.filter(s => s.checked == true);
    }
    else {
      this.mapsSearch = this.mapsSearch.toLowerCase();
      searchResults = this.mapSelection.filter(s => (s.name != undefined ? s.name.toLowerCase().includes(this.mapsSearch) : false) || s.checked == true);
    }

    this.mapsDisplayed = searchResults.sort((x, y) => (x.checked == y.checked) ? 0 : x.checked ? -1 : 1);
    this.mapsSearchNote = `Searched ${this.mapsDisplayed.length} of ${this.mapSelection.length}`;
  }


  searchChartsTextChanged() {
    if (this.isAsteriskSearch(this.chartsSearch)) {
      this.chartsDisplayed = this.firstEntriesForAsteriskSearch(this.chartSelection);
      this.chartsSearchNote = `Searched ${this.chartsDisplayed.length} of ${this.chartSelection.length}`;
      return;
    }

    var searchResults: DashboardChart[] = [];
    const searchLimit = 500;
    let checkedCount = 0;

    if (this.chartsSearch == undefined || this.chartsSearch == '' || this.chartsSearch == 'null') {
      searchResults = this.chartSelection.filter(s => s.checked == true);
    }
    else {
      this.chartsSearch = this.chartsSearch.toLowerCase();
      searchResults = this.chartSelection.filter(s => (s.name != undefined ? s.name.toLowerCase().includes(this.chartsSearch) : false)  || s.checked == true);
    }

    const displayCount = (searchResults.length > checkedCount + searchLimit) ? checkedCount + searchLimit : searchResults.length;

    searchResults = searchResults.sort((x, y) => (x.checked == y.checked) ? 0 : x.checked ? -1 : 1);
    this.chartsDisplayed = searchResults.slice(0, displayCount);

    if (this.chartsDisplayed.length < searchLimit) {
      this.chartsSearchNote = `Searched ${this.chartsDisplayed.length} of ${this.chartSelection.length}`;
    }
    else {
      this.chartsSearchNote = `Searched ${this.chartsDisplayed.length} of ${this.chartSelection.length} (limit)`;
    }
  }


  generateDashboardEventActionSummaries() {
    this._dashboardEventsService.generateDashboardEventActionSummaries(60).subscribe(
      results => {
        if (results != null) {
          console.log(results);
        } else {
          this.toastr.warning('No results.');
        }
        return;
      },
      err => {
        this.toastr.error('Error occurred while retrieving dashboard event action summaries.');
      });

  }



}
